import { assign } from 'lodash';
import moment from 'moment';
import React, { useCallback } from 'react';
import { useMemo } from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { Button, Card, CloseButton, Col, Container, ListGroup, Modal, OverlayTrigger, ProgressBar, Row, Tab, Table, Tabs, Tooltip } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
//import DateTimePicker from 'react-datetime-picker';

import { setDefaults } from 'react-i18next';
import { Step } from 'react-step-progress-bar';
import swal from 'sweetalert';
import { BreadcrumbBox } from '../../../../components/common/Breadcrumb';
import AssignmentService, { ASSIGN_URI, getFileToView, getSolutionFile } from '../../../../services/AssignmentService';
import instructorService from '../../../../services/instructorService';

import UserService from '../../../../services/UserService';
import FilterDataTable from '../../FilterDataTable';
// import AssignStep1 from './AssignStep1';
// import AssignStep2 from './AssignStep2';

import { useTranslation } from 'react-i18next'
import cookies from 'js-cookie';
import md5 from 'md5';
import service, { URI } from '../../../../services/service';
import useNonce from '../../../../helper/Nonce';
import { saveAs } from 'file-saver';
import Swal from 'sweetalert2';
import { Bars } from 'react-loader-spinner';
import CryptoJS from "crypto-js";
import { PreviewModal } from '../CourseStructureDriveNew';
import ViewPdf from '../../ViewPdf';


const languages = [

    {
        code: 'en',
        name: 'English',
        country_code: 'gb',
    },
]






function FrontAssignment(props) {
    const currentLanguageCode = cookies.get('i18next') || 'en'
    const currentLanguage = languages.find((l) => l.code === currentLanguageCode)
    const { t } = useTranslation()
    // // const fetchAndSetNonce = useNonce();
    useEffect(() => {
         document.body.dir = currentLanguage?.dir ?? "ltr";
        document.title = t('app_title')
    }, [currentLanguage, t])

    useEffect(() => {
        UserService.generateToken();
    }, []);


    const userID = props.userID;
    const courseID = props.courseID;
    const tenantID = props.tenantID;
    const isCourseOwner = props.isCourseOwner

    const handleSaveFile = async (uri, filename, fileId) => {
        try {

            const response = await AssignmentService.getfileView(uri, fileId);
            if (filename.match(".zip")) { saveAs(response.data, filename) }
            else if (filename.match(".pdf")) { saveAs(response.data, filename) }
            else if (filename.match(".doc") || filename.match(".docx")) { saveAs(response.data, filename) }
        } catch (error) {
            if (error) {
                swal("Information", "Assignment File does not Exist!", "info");
            }
            // //console.error("error", error)
        }
    }

    const [showPreviewModal, setShowPreviewModal] = useState(false);
    const [contentType, setContentType] = useState("");
    const [previewUrl, setPreviewUrl] = useState("");

    const hidePreviewModal = () => {
        setShowPreviewModal(false);
    }

    const handlePreviewFile = async (uri, filename, fileId) => {
        try {
            await AssignmentService.previewAssignmentFile(uri, fileId)
                .then((response) => {

                    if (filename.match(".zip")) { saveAs(response.data, filename) }
                    else if (filename.match(".pdf")) {

                        const encrypted = CryptoJS.AES.encrypt(
                            "/" + URI.SERVER._MEGH_API + "/" + response.data,
                            "cdac@123"
                        ).toString();
                        const safeEncodedString = encrypted
                            .replace(/\+/g, "-")
                            .replace(/\//g, "_")
                            .replace(/=+$/, "");

                        const pdfDomain = URI.SERVER?._DMS;
                        const finalSubDomain = pdfDomain + "/" + safeEncodedString;

                        setPreviewUrl(finalSubDomain);
                        setContentType("pdf");
                        setShowPreviewModal(true);
                    }
                    else if (filename.match(".doc") || filename.match(".docx")) {
                        saveAs(response.data, filename)

                    }
                }).catch((err) => {
                    swal("Information", "Failed to fetch file", "error");
                });
        } catch (error) {
            if (error) {
                swal("Information", "Assignment File does not Exist!", "error");
            }
            // //console.error("error", error)
        }
    }


    const [assignmentSummaryData, setAssignmentSummaryData] = useState([]);
    const [userSolutionListData, setUserSolutionListData] = useState([]);
    const [solStudFile, setSolStudFile] = useState([]);
    const [selectedLearner, setSelectedLearner] = useState({});
    const [showSummaryModal, setShowSummaryModal] = useState(false);
    const [showSolutionListModal, setShowSolutionListModal] = useState(false);
    const [assignmentSummaryDataLoading, setAssignmentSummaryDataLoading] = useState(false);
    const [solutionListDataLoading, setSolutionListDataLoading] = useState(false);
    const [assignmentSummaryFilterText, setAssignmentSummaryFilterText] = useState('');
    const [assignmentSummarypaginationToggle, setAsssignmentSummarypaginationToggle] = useState(false);
    const [extendDuration, setExtendDuration] = useState(0);
    const [extensioDate, setExtensioDate] = useState(null);
    const [showExtendDaysModal, setShowExtendDaysModal] = useState(false);
    const [extendDaysLoading, setExtendDaysLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [selectedSolutionId, setSelectedSolutionId] = useState(null);
    const [evaluationMarks, setEvaluationMarks] = useState({
        showRejectModal: false,
        marks: '',
        remarks: '',
        row: "",
    });
    const [evaluationMarksError, setEvaluationMarksError] = useState({
        marksError: '',
        remarksError: '',
    });





    const formatDate = (date) => {
        return moment(date).format('YYYY-MM-DD');
    };

    const onDurationChange = (duration) => {
        setExtendDuration(duration);
        const baseDate = solStudFile.extensionCount > 0
            ? moment(solStudFile.extensionDate)  // Use extensionDate if extensionCount > 0
            : moment(); // Use current date otherwise

        setExtensioDate(formatDate(baseDate.add(duration, 'days')));
    }

    const onDurationBlur = () => {
        const errors = {};
        if (isNaN(extendDuration)) {
            errors.duration = "Duration must be a number";
        }
        setErrors(errors);
    }

    const fetchAssignmentSummaryByCourse = () => {
        setAssignmentSummaryDataLoading(true);
        AssignmentService.usersAssignmentSummarByCourseId(courseID)
            .then((res) => {

                setAssignmentSummaryData(res.data);
            })
            .catch((err) => {

            })
            .finally(() => {
                setAssignmentSummaryDataLoading(false);
            })
    }

    const assignmentSummaryDataFiltered = assignmentSummaryData.filter(
        item =>
            item.name?.toLowerCase().includes(assignmentSummaryFilterText.toLowerCase())
            || item.email?.toLowerCase().includes(assignmentSummaryFilterText.toLowerCase())
    );

    const subHeaderComponentUserSummary = useMemo(() => {
        const handleClear = () => {
            if (assignmentSummaryFilterText) {
                setAsssignmentSummarypaginationToggle(!assignmentSummarypaginationToggle);
                setAssignmentSummaryFilterText("");
            }
        };

        return (
            <FilterDataTable
                onFilter={e => setAssignmentSummaryFilterText(e.target.value)}
                onClear={handleClear}
                filterText={assignmentSummaryFilterText}
                placeholder={"Search By Email"}
            />
        );
    }, [assignmentSummaryFilterText, assignmentSummarypaginationToggle]);

    const onClickEValuateAllSolutions = (userId, courseId, data) => {
        setSelectedLearner(data)
        setSolutionListDataLoading(true);
        setShowSolutionListModal(true);

        getSoultionListByUser(userId, courseId)
    }

    const getSoultionListByUser = (userId, courseId) => {
        setSolutionListDataLoading(true);
        AssignmentService.getSolutionsByUserIdCourseId(userId, courseId)
            .then((res) => {
                setUserSolutionListData(res.data);
                setSolutionListDataLoading(false);

            })
            .catch((err) => {
                setShowSolutionListModal(false);
            })
            .finally(() => {
                setSolutionListDataLoading(false);
            })
    }

    const onClickSolListModalClose = () => {
        setShowSolutionListModal(false);
    }

    const resetEvalutionMarks = () => {
        setEvaluationMarks((prev) => {
            return {
                ...prev,
                marks: "",
                remarks: "",
                row: "",
                showRejectModal: false
            }
        })

        setEvaluationMarksError((prev) => {
            return {
                ...prev,
                marksError: "",
                remarksError: ""
            }
        })
    }

    const marksHandler = (event) => {
        setEvaluationMarks({
            ...evaluationMarks,
            [event.target.name]: event.target.value
        })
    }

    function ValidateForm() {
        let marksE = '';
        let remarksE = '';

        if (solStudFile.assignmentType === "reviewtype") {
            if (evaluationMarks.remarks == '') {
                remarksE = t('field_required')
            }
            if (!evaluationMarks.remarks.match(/^[A-Za-z0-9()&.,\"\'\\s ]+$/)) {
                remarksE = "AlphaNumeric with ( ) & . , - \" \' and Space are Allowed "
            }
            if ((remarksE != '' || !evaluationMarks.remarks.match(/^[A-Za-z0-9()&.,\"\'\\s ]+$/))) {
                setEvaluationMarksError({
                    ...evaluationMarksError,
                    remarksError: remarksE,
                })
                return false;
            }
            return true
        }
        else {
            if (evaluationMarks.marks == '') {
                marksE = t('field_required')
            }
            if (evaluationMarks.remarks == '') {
                remarksE = t('field_required')
            }
            if (!evaluationMarks.remarks.match(/^[A-Za-z0-9()&.,\"\'\\s ]+$/)) {
                remarksE = "AlphaNumeric with ( ) & . , - \" \' and Space are Allowed "
            }
            if (marksE != '' && (remarksE != '' || !evaluationMarks.remarks.match(/^[A-Za-z0-9()&.,\"\'\\s ]+$/))) {
                setEvaluationMarksError({
                    ...evaluationMarksError,
                    marksError: marksE,
                    remarksError: remarksE,
                })
                return false;
            }
            return true
        }
    }

    const approveAssignment = (row) => {
        // console.log("ROW ==>", row);

        setSelectedSolutionId(row.solutionId);

        const data = {
            remark: ""
        }
        Swal.fire({
            title: "Confirmation",
            text: "Once approved it cannot be rejected Later",
            icon: "info",
            showConfirmButton: true,
            showCloseButton: true,
        }).then(resp => {
            if (resp.isConfirmed) {
                Swal.fire({
                    title: "Please Wait",
                    showCancelButton: false,
                    showCloseButton: false,
                    showConfirmButton: false,
                    didOpen: () => {
                        Swal.showLoading();
                        AssignmentService.approveAssignment(row.solutionId, data).then((res) => {
                            if (res.status === 200) {
                                Swal.fire({
                                    title: "Success",
                                    text: "Assignment Approve Successfully",
                                    icon: "success",
                                    showConfirmButton: false,
                                    showCloseButton: false,
                                    showCancelButton: false
                                })
                            }
                        }).catch((error) => {
                            Swal.fire({
                                title: "Error",
                                text: "Something went wrong",
                                icon: "error",
                                showConfirmButton: false,
                                showCloseButton: false,
                                showCancelButton: false
                            })
                            resetEvalutionMarks();
                        })
                            .finally(() => {
                                resetEvalutionMarks();
                                getSoultionListByUser(selectedLearner.userId, selectedLearner.courseId)
                            })
                    }
                })
            }
        })
    }

    // console.log("selectedSolutionId ===>", selectedSolutionId);


    const submitRejectAssignmentWithRemarks = () => {
        const status = ValidateForm();
        if (evaluationMarks.remarks == "" || extendDuration === "" || extendDuration === 0 || extendDuration === null) {
            Swal.fire({
                title: "Warning",
                text: "Remarks and extend duration can not be Empty",
                icon: "warning",
            })
        }

        const data = {
            remarks: evaluationMarks.remarks,
            duration: extendDuration
        }

        if (status) {

            Swal.fire({
                title: "Please Wait",
                showCancelButton: false,
                showCloseButton: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading();
                    AssignmentService.rejectAssignment(selectedSolutionId, data).then((res) => {
                        if (res.status === 200) {
                            Swal.fire({
                                title: "Success",
                                text: "Assignment Reject Successfully",
                                icon: "success",
                                showConfirmButton: false,
                                showCloseButton: false,
                                showCancelButton: false
                            })
                            getSoultionListByUser(selectedLearner.userId, selectedLearner.courseId);
                        }
                    }).catch((error) => {
                        Swal.fire({
                            title: "Error",
                            text: "Something went wrong",
                            icon: "error",
                            showConfirmButton: false,
                            showCloseButton: false,
                            showCancelButton: false
                        })
                    })
                        .finally(() => {
                            resetEvalutionMarks();
                            // getSoultionListByUser(selectedLearner.userId, selectedLearner.courseId)
                        })
                }
            })
        }
    }

    const rejectAssignment = (row) => {
        // console.log("row ==>", row);

        setSelectedSolutionId(row.solutionId);
        setEvaluationMarks((prev) => {
            return {
                ...prev,
                showRejectModal: true,
                row: row
            }
        })
    }

    const extendDurationClick = (row) => {
        setSolStudFile(row);
        setShowExtendDaysModal(true);
    }

    const closeExtendModal = () => {
        setShowExtendDaysModal(false);
        setExtendDuration(false);
        setSolStudFile(null);
    }

    // console.log("solStudFile ===> ", solStudFile);

    const extendDurationSubmit = () => {
        setExtendDaysLoading(true);

        if (Object.keys(errors).length !== 0) {
            swal("Warning", "Please Check the duration again", "warning");
            setExtendDaysLoading(false);
            return;
        }

        const data = [
            {
                "userId": solStudFile.submittedBy,
                "solutionId": solStudFile.solutionId,
                "extensionDays": extendDuration
            }
        ]

        // console.log("data ===> ", data);

        AssignmentService.updateUserAssignmentSubmissionDuration(data)
            .then((res) => {
                if (res.status === 200) {
                    swal("Success", "Successfully Updated the Dates", "success")
                }
            })
            .catch((err) => {
                swal("Error", "Internal Server Error! Contact Admin", "error");
            })
            .finally(() => {
                setExtendDaysLoading(false);
                setShowExtendDaysModal(false);
                getSoultionListByUser(selectedLearner.userId, selectedLearner.courseId)
            });

    }

    const assignmentSummaryColumns = [
        {
            name: 'Name',
            selector: row => row.firstName + " " + row.lastName,
            sortable: true,
            wrap: true,

        },
        {
            name: 'Email',
            selector: row => row.email,
            sortable: true,
            wrap: true,

        },
        {
            name: 'totalAssignments',
            selector: row => row.totalAssignments,
            sortable: true,
            wrap: true,
        },
        {
            id: 'submittedAssignments',
            name: 'Submitted Assignments',
            selector: row => row.submittedCount,
            sortable: true,
            wrap: true,
        },
        {
            name: 'Approved Assignments',
            selector: row => row.totalApproved,
            sortable: true,
            wrap: true,
        },
        {
            name: 'Rejected Assignments',
            selector: row => row.totalRejetced,
            sortable: true,
            wrap: true,
        },
        {
            name: 'Action',
            width: '200px',
            cell: row => <>
                <div style={{ whiteSpace: "nowrap" }}>
                    <OverlayTrigger
                        overlay={
                            <Tooltip
                                id="tooltip-disabled">
                                Evaluate Solutions
                            </Tooltip>
                        }
                    >
                        <button
                            className='btn btn-info'
                            style={{ marginRight: '5px' }}
                            onClick={() => {
                                onClickEValuateAllSolutions(row.userId, row.courseId, row);
                            }} >
                            <i class="fas fa-book-open"></i>
                        </button>
                    </OverlayTrigger>

                </div>
            </>
        }
    ]

    // console.log("selectedLearner ==>", selectedLearner);


    const solutionListColumns = [
        {
            name: 'Assignment Name',
            selector: row => row.assignmentName || "N/A",
            sortable: true,
            wrap: true,
        },
        {
            name: 'Solution File Name',
            selector: row => row.filename || "No File",
        },
        {
            name: "Preview",
            cell: (row) =>
                <>
                    {row?.filename ? (
                        <a className='link' href="#" >
                            {
                                row.filename.match(".zip") ? (
                                    <div onClick={() => handlePreviewFile(ASSIGN_URI._PREVIEW_STUDENT_FILE, row.filename, row.solutionFileSno)}>
                                        <i className="fas fa-file-archive" style={{ fontSize: "35px", color: "#fdbf00" }}></i>
                                    </div>
                                ) : row.filename.match(".pdf") ? (
                                    <div onClick={() => handlePreviewFile(ASSIGN_URI._PREVIEW_STUDENT_FILE, row.filename, row.solutionFileSno)} style={{ cursor: "pointer" }}>
                                        <i className="fas fa-file-pdf" style={{ fontSize: "35px", color: "#b30b00" }}></i>
                                    </div>
                                ) : row.filename.match(".doc") || row.filename.match(".docx") ? (
                                    <div onClick={() => handlePreviewFile(ASSIGN_URI._PREVIEW_STUDENT_FILE, row.filename, row.solutionFileSno)}>
                                        <i className="fas fa-file-word" style={{ fontSize: "35px", color: "#2596be" }}></i>
                                    </div>
                                ) : null
                            }
                        </a>
                    ) : (
                        <span style={{ color: "gray" }}>No Preview</span>
                    )}
                </>
        },
        {
            name: "Download",
            cell: (row) =>
                <>
                    {row?.filename ? (
                        <a className='link' href="#" >
                            {
                                row.filename.match(".zip") ? (
                                    <div onClick={() => handleSaveFile(ASSIGN_URI._GET_STUDENT_FILE, row.filename, row.solutionFileSno)}>
                                        <i className="fas fa-file-archive" style={{ fontSize: "35px", color: "#fdbf00" }}></i>
                                    </div>
                                ) : row.filename.match(".pdf") ? (
                                    <div onClick={() => handleSaveFile(ASSIGN_URI._GET_STUDENT_FILE, row.filename, row.solutionFileSno)} style={{ cursor: "pointer" }}>
                                        <i className="fas fa-file-pdf" style={{ fontSize: "35px", color: "#b30b00" }}></i>
                                    </div>
                                ) : row.filename.match(".doc") || row.filename.match(".docx") ? (
                                    <div onClick={() => handleSaveFile(ASSIGN_URI._GET_STUDENT_FILE, row.filename, row.solutionFileSno)}>
                                        <i className="fas fa-file-word" style={{ fontSize: "35px", color: "#2596be" }}></i>
                                    </div>
                                ) : null
                            }
                        </a>
                    ) : (
                        <span style={{ color: "gray" }}>No File</span>
                    )}
                </>
        },
        ,
        {
            name: 'Status',
            selector: row => (row.status == "approve" ? "Approved" : row.status == "reject" ? "Resubmit" : row.status == "reupload" ? "Resubmit" : row.status == "submitted" ? "Submitted" : "N/A"),
        },
        ,
        {
            name: 'Extended Date',
            selector: row => row.extensionDate != null ? formatDate(row.extensionDate) : "Not Extended",
        },
        {
            name: 'Extension Count',
            selector: row => row.extensionCount,
        },
        {
            name: "Action",
            cell: (row) =>
                <>
                    {
                        row?.status === "submitted" ? (
                            <>
                                <OverlayTrigger overlay={<Tooltip id="tooltip-approve">Approve</Tooltip>}>
                                    <button type="button" onClick={() => approveAssignment(row)}
                                        className="btn m-2" style={{ background: "green", color: "white" }}>
                                        <i className="fa fa-thumbs-up"></i>
                                    </button>
                                </OverlayTrigger>
                                <OverlayTrigger overlay={<Tooltip id="tooltip-resubmit">Resubmit</Tooltip>}>
                                    <button type="button" onClick={() => rejectAssignment(row)}
                                        className="btn btn-danger m-2">
                                        <i className="fa fa-thumbs-down"></i>
                                    </button>
                                </OverlayTrigger>
                            </>
                        ) : row?.status === "approve" ? (
                            <OverlayTrigger overlay={<Tooltip id="tooltip-approved">Already Approved</Tooltip>}>
                                <button disabled className="btn m-2" style={{ background: "green", color: "white" }}>
                                    <i className="fa fa-thumbs-up"></i>
                                </button>
                            </OverlayTrigger>
                        ) : row?.status === "reject" ? (
                            <OverlayTrigger overlay={
                                <Tooltip
                                    id="tooltip-rejected">
                                    Resubmit
                                </Tooltip>}>
                                <button disabled className="btn btn-danger m-2">
                                    <i className="fa fa-thumbs-down"></i>
                                </button>
                            </OverlayTrigger>
                        ) : null
                    }

                    {
                        (row?.status === "reject" || row?.status === "reupload") ?
                            <OverlayTrigger overlay={<Tooltip id="tooltip-approve">Extend Duration</Tooltip>}>
                                <button
                                    type="button"
                                    onClick={() => extendDurationClick(row)}
                                    className="btn m-2"
                                    style={{ background: "green", color: "white" }}
                                >
                                    <i className="fa fa-history"></i>
                                </button>
                            </OverlayTrigger>
                            : ""
                    }
                </>
        }
    ];

    const onClickAssignmentSummary = () => {
        fetchAssignmentSummaryByCourse();
        setShowSummaryModal(true);
    }

    const onClickModalClose = () => {
        setShowSummaryModal(false);
        setAssignmentSummaryFilterText("");
    }

    /*********************************** MAIN FRONT COMPONENT ************************/
    const [comp, setComp] = useState(<ViewAssignment />);
    return (
        <>
            {comp}
            <PreviewModal
                show={showPreviewModal}
                onHide={hidePreviewModal}
                contentType={contentType}
                url={previewUrl}
                videoEncodeStatus={false}
            />

            <Modal
                centered
                show={showSummaryModal}
                onHide={onClickModalClose}
                fullscreen={true}
                backdrop="static"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Course Wise Assignement Summary</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='modal-main-body'
                        style={{ minHeight: "85vh" }}
                    >
                        {

                            assignmentSummaryDataLoading ?
                                <>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
                                        <Bars height={40} width={40} color="#0C122Fff" ariaLabel="circles-loading" />
                                    </div>
                                </>
                                :
                                <>
                                    <Card>
                                        <DataTable
                                            columns={assignmentSummaryColumns}
                                            data={assignmentSummaryDataFiltered}
                                            defaultSortFieldId="submittedAssignments"
                                            defaultSortAsc={false}
                                            striped
                                            pagination
                                            highlightOnHover
                                            subHeader
                                            subHeaderComponent={subHeaderComponentUserSummary}
                                            fixedHeader
                                            fixedHeaderScrollHeight="72vh"
                                        />
                                    </Card>
                                </>
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="danger"
                        onClick={onClickModalClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal >

            <Modal
                centered
                show={showSolutionListModal}
                onHide={onClickSolListModalClose}
                fullscreen={true}
                backdrop="static"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Solution List</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='modal-main-body'
                        style={{ minHeight: "85vh" }}
                    >
                        {

                            solutionListDataLoading ?
                                <>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
                                        <Bars height={40} width={40} color="#0C122Fff" ariaLabel="circles-loading" />
                                    </div>
                                </>
                                :
                                <>
                                    <Card>
                                        <DataTable
                                            columns={solutionListColumns}
                                            data={userSolutionListData}
                                            pagination
                                            highlightOnHover
                                        />
                                    </Card>
                                </>
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="danger"
                        onClick={onClickSolListModalClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal >

            <Modal
                size='lg'
                centered
                backdrop="static"
                show={evaluationMarks.showRejectModal}
                onHide={() => setEvaluationMarks((prev) => ({ ...prev, showRejectModal: false, marks: '', remarks: '', row: '' }))}>
                <Modal.Header>
                    <h5>Please provide remarks</h5>
                </Modal.Header>
                <Modal.Body>
                    <div style={{ margin: '0px', width: '100%' }}>
                        <p style={{ fontSize: '15px', fontWeight: '500' }}>Remarks:</p>
                        <textarea
                            className="form-control"
                            placeholder='Remarks is Mandatory'
                            name='remarks'
                            minLength={2}
                            maxLength={150}
                            value={evaluationMarks.remarks}
                            onChange={marksHandler}
                        />
                        <br />

                        <p style={{ fontSize: '14px', color: '#6c757d', marginTop: '5px' }}>
                            Enter the Duration (in Days) till which you want to extend the resubmission of the assignment:
                        </p>

                        <div
                            style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: '10px',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                            }}
                        >
                            <input
                                type="number"
                                className="form-control"
                                style={{
                                    flex: '1',
                                    minWidth: '150px', // Ensures proper spacing on smaller screens
                                }}
                                value={extendDuration}
                                onChange={(e) => onDurationChange(e.target.value)}
                                onBlur={() => onDurationBlur()}
                                placeholder="Enter the Days to extend"
                                min={0}
                            />

                            <input
                                type="date"
                                className="form-control"
                                style={{
                                    flex: '1',
                                    minWidth: '150px', // Ensures proper spacing on smaller screens
                                }}
                                value={formatDate(extensioDate)}
                                disabled={true}
                            />
                        </div>

                        {errors?.duration && <span className="error-message">{errors?.duration}</span>}

                        <p style={{ fontSize: '14px', color: '#6c757d', marginTop: '5px' }}>
                            Once you have selected Resubmit, you cannot evaluate the assignment again unless the learner uploads a new assignment.
                        </p>
                    </div>

                    {evaluationMarksError.remarksError && <div className="alert alert-danger mt-2">{evaluationMarksError.remarksError}</div>}
                    {/* <CourseDurationUpdate /> */}
                    <div style={{ display: 'flex', margin: '15px 0px' }}>
                        <Button
                            variant='success'
                            onClick={submitRejectAssignmentWithRemarks}
                        >
                            Submit
                        </Button>
                        <Button
                            variant='danger'
                            style={{ marginLeft: '5px' }}
                            onClick={() => setEvaluationMarks((prev) => ({ ...prev, marks: '', remarks: '', row: '', showRejectModal: false }))}
                        >
                            Cancel
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal
                size='lg'
                centered
                backdrop="static"
                show={showExtendDaysModal}
            >
                <Modal.Header>
                    <h5>Please provide remarks</h5>
                </Modal.Header>
                <Modal.Body>
                    <Row style={{ marginBottom: "30px", padding: "20px" }}>
                        <Col md={8}>
                            <div className='input-area-duration'>
                                <label className='label-duration'>
                                    Assignment Resubmission Extend (in Days):
                                    <OverlayTrigger
                                        overlay={
                                            <Tooltip id="tooltip-d isabled">
                                                Enter the Duration (in Days) by which you want to extend the Assignment Submission deadline for User(s)
                                            </Tooltip>
                                        }
                                    >
                                        <i className="fa fa-info-circle" style={{ fontSize: '18px', marginLeft: "5px" }}></i>
                                    </OverlayTrigger>
                                </label>
                                <input
                                    type="number"
                                    className="extendedDuration-form"
                                    value={extendDuration}
                                    onChange={(e) => onDurationChange(e.target.value)}
                                    onBlur={() => onDurationBlur()}
                                    placeholder="Enter Duration in Days"
                                />
                                {errors?.duration && <span className="error-message">{errors?.duration}</span>}
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className='submit-button-area d-flex justify-content-end'>
                                <Button
                                    size='lg'
                                    className='submit-button mr-2 btn-success'
                                    onClick={extendDurationSubmit}
                                    disabled={extendDaysLoading}
                                >
                                    {extendDaysLoading ? "Loading ...." : "Submit"}
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant='danger'
                        style={{ marginLeft: '5px' }}
                        onClick={closeExtendModal}
                    >
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

        </>
    );

    /*********************************** VIEW ASSIGNMENT ***********************************/
    function ViewAssignment(props) {
        const currentLanguageCode = cookies.get('i18next') || 'en'
        const currentLanguage = languages.find((l) => l.code === currentLanguageCode)
        const { t } = useTranslation()
        const [getAssignmentDetails, setAssignmentDetails] = useState(false)
        const [getRow, setRow] = useState(null)
        const [getCourseOwner, setCourseOwner] = useState(false);

        useEffect(() => {
             document.body.dir = currentLanguage?.dir ?? "ltr";
            document.title = t('app_title')
        }, [currentLanguage, t])
        const [getInstructors, setInstructors] = useState({});
        useEffect(() => {
            getInstDetials()


        }, [])
        const getInstDetials = async () => {
            await service.getInstructorDetails(courseID, 1).then((res) => {

                if (res.status === 200) {
                    instructorService.isCourseOwner(userID, courseID).then((res) => {

                        if (res.data) {
                            //course owner have all access
                            setCourseOwner(res.data)

                        }


                    }).catch((err) => {
                        swal(`${t('error')}`, err.response.data, "error");
                    })
                    let instDetails = res.data.reduce((instDetailsObj, obj) => {
                        const { learnerUsername } = obj;
                        if (!instDetailsObj[learnerUsername]) {
                            instDetailsObj[learnerUsername] = []; // Initialize as array
                        }
                        instDetailsObj[learnerUsername].push(obj); // Push object to array
                        return instDetailsObj; // Return accumulator
                    }, {});
                    setInstructors(instDetails)

                }
            }).catch((err) => {
                // //console.error("Error:", err);
            });


        }

        const customStyles = {
            title: {
                style: {
                    fontColor: 'red',
                    fontWeight: '900',
                }
            },

            rows: {
                style: {
                    minHeight: '72px'
                },
            },

            headCells: {
                style: {

                    widthRight: '8px',
                    widthLeft: '8px',
                    fontSize: '17px',
                },
            },
            cells: {
                style: {
                    widthRight: '8px',
                    widthLeft: '8px',
                    fontSize: '15px',
                },
            },
        };

        useEffect(() => {
            assignmentListAPI();
        }, [])
        const assignmentListAPI = async () => {
            try {
                let result = await AssignmentService.getAssignDetail(UserService.getUserid(), courseID, tenantID)
                if (result.status === 200)
                    setAssignmentList(result.data);
            } catch (error) {

            }
        }

        const [getAssignmentList, setAssignmentList] = useState([]);
        const [filterText, setFilterText] = useState('');
        const [resetPaginationToggle, setResetPaginationToggle] = useState(
            false
        );

        const filteredAssignmentList = getAssignmentList.filter(
            item =>
                item.name.toLowerCase()
                    .indexOf(filterText.toLowerCase()) !== -1
        );

        const subHeaderComponent = useMemo(() => {
            const handleClear = () => {
                if (filterText) {
                    setResetPaginationToggle(!resetPaginationToggle);
                    setFilterText("");
                }
            };

            return (
                <FilterDataTable
                    onFilter={e => setFilterText(e.target.value)}
                    onClear={handleClear}
                    filterText={filterText}
                />
            );
        }, [filterText, resetPaginationToggle]);



        const deleteAssign = (assignID) => {
            instructorService.checkContentStatus(assignID, "assignment").then(async (res) => {
                if (res.data === true) {
                    await swal(
                        t('msg'),
                        t('this_content_map_mydrive'),
                        "warning"
                    );
                } else {
                    swal({
                        title: `${t("r_u_sure")}`,
                        text: `${t("u_want_to_delete_content")}`,
                        icon: "warning",
                        buttons: [t("no_cancel"), t("yes_delete")],
                        dangerMode: true,
                    }).then((isConfirmed) => {
                        if (isConfirmed) {
                            AssignmentService.deleteAssignment(assignID).then(async (res) => {
                                if (res.status == 200) {
                                    await swal(
                                        t('deleted'),
                                        t('your_content_deleted'),
                                        "success"
                                    );
                                    assignmentListAPI();
                                }
                            });
                        }
                    });
                }
            });
        };


        const uploadFile = (assignID) => {
            setComp(
                <AssignStep2
                    uploadFileClick={true}
                    steps={2}
                    assignID={assignID}
                    courseID={courseID}
                    tenantID={tenantID}
                />
            )
        }
        function onClickEvaluationButton(courseID, tenantID, assignID, assignType) {
            setComp(
                <>
                    <Evaluation
                        courseID={courseID}
                        tenantID={tenantID}
                        assignID={assignID}
                        assignType={assignType}
                    />
                </>
            )
        }
        function onClickEdit(assignID, name, totalMarks, passMark, description, openingDate, closingDate, assignType, mailStatus) {

            setComp(
                <CreateAssignment
                    updateAssignment={true}
                    assignID={assignID}
                    name={name}
                    totalMarks={totalMarks}
                    passMarks={passMark}
                    description={description}
                    openDate={openingDate}
                    closeDate={closingDate}
                    assignType={assignType}
                    mailstatus={mailStatus}
                    courseID={courseID}
                    tenantID={tenantID}
                />
            )

        }

        const columnViewAssignment = [
            {
                name: 'Assignment Name',
                selector: row => row.name,
                sortable: true,
                wrap: true,
                width: '200px',
            },
            {
                name: 'Description',
                selector: row => row.description,
                wrap: true
            },
            {
                name: 'Author',
                selector: row => getInstructors[row.createdBy]?.[0]?.firstName || "--",
                wrap: true
            },
            {
                name: 'View',
                selector: row =>
                    <>
                        <Button style={{ whiteSpace: "nowrap" }} variant='info' onClick={() => { toggleViewAssignment(row) }}>More Details</Button>
                    </>,
                wrap: true,
                width: '200px',
            },
            {
                name: 'Action',
                width: '200px',
                cell: row => <>
                    <div style={{ whiteSpace: "nowrap" }}>
                        {UserService.getUserid() === row.createdBy || getCourseOwner
                            ?
                            <>
                                {/* {//console.log('Check-----', row.assignmentFilePath.length)} */}
                                {/* <button className='btn btn-primary' style={{ marginRight: '5px' }} onClick={() => { onClickEdit(row.assignment_id, row.name, row.totalMarks, row.passMarks, row.description, row.openingDate, row.closingDate) }} ><i class="fas fa-edit"></i> </button> */}
                                {
                                    row.assignmentFilePath.length > 0 ?
                                        <>
                                            <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">{t('edit_assign')}</Tooltip>}>
                                                <button className='btn btn-info' style={{ marginRight: '5px' }} onClick={() => { onClickEdit(row.assignment_id, row.name, row.totalMarks, row.passMarks, row.description, row.openingDate, row.closingDate, row.assignType, row.mailStatus) }} ><i class="fas fa-edit"></i> </button>
                                            </OverlayTrigger>
                                            <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">{t('upload_file')}</Tooltip>}>
                                                <button className='btn btn-info' onClick={() => { uploadFile(row.assignment_id) }} style={{ marginRight: '5px' }} ><i class="fas fa-upload"></i> </button>
                                            </OverlayTrigger>
                                        </>
                                        :
                                        <>
                                            <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">{t('upload_file')}</Tooltip>}>
                                                <button className='btn btn-info' onClick={() => { uploadFile(row.assignment_id) }} style={{ marginRight: '5px' }} ><i class="fas fa-upload"></i> </button>
                                            </OverlayTrigger>
                                        </>
                                }
                                {/* {
                                    !row.assignmentFilePath
                                        ?
                                        <>

                                        </>
                                        :
                                        <>
                                        </>
                                } */}
                                {/* <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">{t('evaluate_assign')}</Tooltip>}>
                                    <button className='btn btn-success' onClick={() => { onClickEvaluationButton(courseID, tenantID, row.assignment_id, row.assignType) }} style={{ marginRight: '5px' }} ><i class="fas fa-book-open"></i> </button>
                                </OverlayTrigger> */}
                                <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">{t('delete_assign')}</Tooltip>}>
                                    <button className='btn btn-danger' onClick={() => { deleteAssign(row.assignment_id) }} ><i class="fas fa-trash"></i> </button>
                                </OverlayTrigger>
                            </>
                            :
                            <>
                            </>
                        }
                    </div>
                </>
            }
        ]

        const onClickCreateAssign = () => {
            setComp(
                <CreateAssignment />)
        }
        const toggleViewAssignment = (row) => {


            setRow(row)
            setAssignmentDetails(prevState => !prevState)

        }

        return (
            <>
                <Row className="justify-content-center" style={{ marginBottom: "20px" }}>
                    <Col xs={12} sm="auto" className="d-flex justify-content-center mb-2 mb-sm-0">
                        <Button
                            type="submit"
                            onClick={() => { onClickCreateAssign(); }}
                            className="btn btn-primary"
                            style={{
                                minWidth: '120px',
                                padding: '8px 12px',
                                fontSize: '13px',
                                borderRadius: '6px',
                                textAlign: 'center',
                            }}
                        >
                            {t('create_assign')}
                        </Button>
                    </Col>

                    <Col xs={12} sm="auto" className="d-flex justify-content-center">
                        <Button
                            onClick={() => onClickAssignmentSummary()}
                            className="btn btn-primary"
                            style={{
                                minWidth: '120px',
                                padding: '8px 12px',
                                fontSize: '13px',
                                borderRadius: '6px',
                                textAlign: 'center',
                            }}
                        >
                            Assignment Evaluation
                        </Button>
                    </Col>
                </Row>
                <div className='shadow-lg p-3 bg-body rounded'>
                    <div className='card'>
                        <div className='card-body'>
                            <h5>{t('assign_list')}</h5>
                            <br />
                            <Card>
                                <DataTable
                                    columns={columnViewAssignment}
                                    data={filteredAssignmentList}
                                    defaultSortField="Name"
                                    defaultSortAsc={true}
                                    striped
                                    pagination
                                    highlightOnHover
                                    customStyles={customStyles}
                                    subHeader
                                    subHeaderComponent={subHeaderComponent}
                                    fixedHeader
                                    fixedHeaderScrollHeight="300px"
                                />
                            </Card>
                        </div>
                    </div>
                </div>
                {/*  view */}
                <Modal
                    centered
                    show={getAssignmentDetails}
                    onHide={toggleViewAssignment}
                    size="xl"
                    backdrop="static"
                    scrollable

                >
                    <Modal.Header closeButton>
                        <Modal.Title>Assignment Details</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {/* {getRow} */}
                        <Card className='w-100 text-center'>
                            <Card.Body>
                                <Card.Title>{getRow?.name}</Card.Title>
                                <Card.Subtitle className="mb-2 text-muted">{getRow?.description}</Card.Subtitle>
                                <Card.Text>

                                    <Table responsive>
                                        <thead>
                                            <tr>
                                                <th>Total Marks</th>
                                                <th>Passing Marks</th>
                                                <th>Start Date</th>
                                                <th>End Date</th>
                                                <th>Files & Preview</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>{getRow?.totalMarks}</td>
                                                <td>{getRow?.passMarks}</td>
                                                <td>{getRow?.createdDate}</td>
                                                <td>{getRow?.closingDate}</td>
                                                <td>
                                                    <ListGroup defaultActiveKey="#link1">
                                                        {
                                                            getRow?.assignmentFilePath?.map((filename) => (
                                                                <div key={filename?.id} onClick={() => { handleSaveFile(ASSIGN_URI._GET_FILE_TO_VIEW, filename?.filename, filename?.id) }} rel="noopener noreferrer">
                                                                    <ListGroup.Item className='text-info' style={{ cursor: "pointer" }}>
                                                                        {filename?.filename}
                                                                    </ListGroup.Item>
                                                                </div>
                                                            ))
                                                        }
                                                    </ListGroup>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>


                                </Card.Text>
                                {/* <Card.Link href="#">Card Link</Card.Link>
                                <Card.Link href="#">Another Link</Card.Link> */}
                            </Card.Body>
                        </Card>

                    </Modal.Body>
                    <Modal.Footer>

                        <Button variant="danger" onClick={toggleViewAssignment}>
                            Close
                        </Button>
                        {/* You can add additional buttons or actions here */}
                    </Modal.Footer>
                </Modal>

            </>
        )
    }

    /***********************************   Creating Assignment Function ******************************/

    /*****PARENT COMPONENT OF AssignStep1 and AssignStep2 */
    function CreateAssignment(props) {
        const currentLanguageCode = cookies.get('i18next') || 'en'
        const currentLanguage = languages.find((l) => l.code === currentLanguageCode)
        const { t } = useTranslation()

        useEffect(() => {
             document.body.dir = currentLanguage?.dir ?? "ltr";
            document.title = t('app_title')
        }, [currentLanguage, t])

        const assignID = props.assignID
        const onClickClose = () => {
            setComp(<ViewAssignment />)
        }
        const [getServerTime, setServerTime] = useState();
        const [showCreateAssignment, setShowCreateAssignment] = useState(true);
        const [swalMsg, setSwalMsg] = useState(t('assign_data_msg'))

        useEffect(() => {

            instructorService.getServerTime()
                .then(res => {
                    let serTime = res.data;
                    setServerTime(serTime);
                    setServerTime(serTime.replace(/\s/g, 'T'));
                    // var arr = serTime.split(" ");
                    // setDateTime(arr);
                })
            if (props.assignID) {
                setAssignmentData({
                    steps: 1,
                    updateAssignment: props.updateAssignment,
                    name: props.name,
                    totalMarks: props.totalMarks,
                    passMarks: props.passMarks,
                    description: props.description,
                    openDate: props.openDate,
                    closeDate: props.closeDate,
                    assignID: props.assignID,
                    assignType: props.assignType,
                    mailstatus: props.mailstatus,
                })
                setSwalMsg(t('assign_update_msg'))
                setSuccessMsg(t('success'))
                setDefaultDate({
                    ...defaultDate,
                    defaultOpeningDate: props.openDate,
                    defaultClosingDate: props.closeDate,
                })
            }
        }, [])

        const [defaultDate, setDefaultDate] = useState({
            defaultOpeningDate: '',
            defaultClosingDate: ''
        });


        const [successMsg, setSuccessMsg] = useState();
        const [assignmentData, setAssignmentData] = useState({
            steps: 1,//steps: 1,
            updateAssignment: '',
            name: '',
            totalMarks: '',
            passMarks: '',
            description: '',
            openDate: '',
            closeDate: '',
            assignID: '',// assignID: undefined,
            assignType: '',
            mailstatus: '',
        })

        const handleChange = (event) => {
            setAssignmentData({
                ...assignmentData, [event.target.name]: event.target.value
            })
        }

        const [assignFormError, setAssignFormError] = useState({
            nameError: '',
            totalMarksError: '',
            passMarksError: '',
            descriptionError: '',
            openDateError: '',
            openTimeError: '',
            closeDateError: '',
            closeTimeError: '',
            assignTypeError: "",
            mailstatusError: "",
        })




        function assignmentFormValidate() {


            let nameE = '';
            let totalMarksE = '';
            let passMarksE = '';
            let descriptionE = '';
            let openDateE = '';
            let closeDateE = '';
            let assignTypeErr = '';
            let emailstatusErr = '';

            if (assignmentData.name == '') {
                nameE = t('assign_name_req')
            } else if (assignmentData.name.match(/^[A-Za-z0-9()&.,\- ]+$/)) {
                nameE = '';
            } else if (assignmentData.name.length > 150) {
                nameE = "Maximun 150 Character are Allowed";
            } else if (assignmentData.name.length < 2) {
                nameE = "Minimun 2 Character are Allowed";
            } else {
                nameE = "AlphaNumeric with ( ) & . , - and Space are Allowed ";
            }

            if (assignmentData.assignType === "marktype") {
                if (assignmentData.passMarks == '') {
                    passMarksE = t('passing_mark_req')
                }
                if (parseInt(assignmentData.passMarks) > parseInt(assignmentData.totalMarks)) {
                    passMarksE = t('not_greater_than_total')
                }
                if (parseInt(assignmentData.passMarks) <= 0) {
                    passMarksE = t('not_negative')
                }
                if (parseInt(assignmentData.totalMarks) <= 0) {
                    totalMarksE = t('not_negative')
                }
                if (assignmentData.totalMarks == '') {
                    totalMarksE = t('total_mark_req')
                }
            }

            if (assignmentData.mailstatus === "mailstatus") {
                passMarksE = "Select Receive E-Mail Status"
            }

            if (assignmentData.description == '') {
                descriptionE = t('assign_desc_require')
            } else if (assignmentData.description.match(/^[A-Za-z0-9()&.,\"\'\\s ]+$/)) {
                nameE = '';
            } else if (assignmentData.description.length > 150) {
                nameE = "Maximun 150 Character are Allowed";
            } else if (assignmentData.description.length < 2) {
                nameE = "Minimun 2 Character are Allowed";
            } else {
                nameE = "AlphaNumeric with ( ) & . , - and Space are Allowed ";
            }


            if (assignmentData.openDate == '') {
                openDateE = t('open_date_req')
            }

            if (assignmentData.closeDate == '') {
                closeDateE = t('close_date_req')
            }

            if (assignmentData.updateAssignment) {
                if (defaultDate.defaultOpeningDate) {
                    //const openDateTime = assignmentData.openDate;
                    const defOpenDate = new Date(defaultDate.defaultOpeningDate).getTime();
                    const openingAssignDate = new Date(assignmentData.openDate).getTime();
                    if (openingAssignDate < defOpenDate) {
                        openDateE = t('not_greater_opening_date')
                    }
                }
            }
            else {
                const serv = new Date(getServerTime).getTime();
                const openingAssignDate = new Date(assignmentData.openDate).getTime();
                if (openingAssignDate < serv) {
                    openDateE = t('greater_than_current_time')
                }
            }


            if (assignmentData.openDate && assignmentData.closeDate) {
                const openDateTime = assignmentData.openDate
                const closeDateTime = assignmentData.closeDate
                const closingAssignDate = new Date(closeDateTime).getTime();
                const openingAssignDate = new Date(openDateTime).getTime();
                if (closingAssignDate < openingAssignDate) {
                    closeDateE = t('opening_date_greater')
                }
            }

            if (nameE !== '' || totalMarksE !== '' || passMarksE !== '' || descriptionE !== '' || openDateE !== '' || closeDateE !== '' || emailstatusErr !== '') {
                setAssignFormError({
                    ...assignFormError,
                    nameError: nameE,
                    totalMarksError: totalMarksE,
                    passMarksError: passMarksE,
                    descriptionError: descriptionE,
                    openDateError: openDateE,
                    closeDateError: closeDateE,
                    assignTypeError: assignTypeErr,
                    mailstatusError: emailstatusErr,
                })
                return false;
            }
            return true
        }

        const onClickNext = () => {
            // dateHandler();

            if (assignmentData.updateAssignment) {
                const check = assignmentFormValidate();
                if (check == true) {
                    assignmentDataService();
                }
            }
            else if (assignmentData.assignID) {
                setAssignmentData({
                    ...assignmentData,
                    steps: 2,
                })

            }
            else {
                const check = assignmentFormValidate();
                if (check == true) {

                    assignmentDataService();
                }
            }
        }



        var OpenTime = ''
        var CloseTime = ''
        const assignmentDataService = async () => {
            // await fetchAndSetNonce();
            if (assignmentData.updateAssignment) {

                var openDate, openMonth, openYear, openHour, openMinute, openSecond;
                var openDate1, openMonth1, openYear1, openHour1, openMinute1, openSecond1;
                var closeDate, closeMonth, closeYear, closeHour, closeMinute, closeSecond;
                var closeDate1, closeMonth1, closeYear1, closeHour1, closeMinute1, closeSecond1;
                openDate = new Date(assignmentData.openDate).getDate();
                openMonth = (new Date(assignmentData.openDate).getMonth()) + 1;
                openYear = new Date(assignmentData.openDate).getFullYear();
                openHour = new Date(assignmentData.openDate).getHours();
                openMinute = new Date(assignmentData.openDate).getMinutes();

                closeDate = new Date(assignmentData.closeDate).getDate();
                closeMonth = (new Date(assignmentData.closeDate).getMonth()) + 1;
                closeYear = new Date(assignmentData.closeDate).getFullYear();
                closeHour = new Date(assignmentData.closeDate).getHours();
                closeMinute = new Date(assignmentData.closeDate).getMinutes();

                openDate1 = openDate < 10 ? '0' + openDate : openDate;
                openMonth1 = openMonth < 10 ? '0' + openMonth : openMonth;
                openHour1 = openHour < 10 ? '0' + openHour : openHour;
                openMinute1 = openMinute < 10 ? '0' + openMinute : openMinute;

                closeDate1 = closeDate < 10 ? '0' + closeDate : closeDate;
                closeMonth1 = closeMonth < 10 ? '0' + closeMonth : closeMonth;
                closeHour1 = closeHour < 10 ? '0' + closeHour : closeHour;
                closeMinute1 = closeMinute < 10 ? '0' + openMinute : closeMinute;

                OpenTime = openYear + '-' + openMonth1 + '-' + openDate1 + "%20" + openHour1 + '%3A' + openMinute1 + '%3A00'
                CloseTime = closeYear + '-' + closeMonth1 + '-' + closeDate1 + "%20" + closeHour1 + '%3A' + closeMinute1 + '%3A00'

                const assignmentName = assignmentData.name.trim();
                const totalMarks = assignmentData.assignType === "marktype" ? parseInt(assignmentData.totalMarks) : ""
                const passMarks = assignmentData.assignType === "marktype" ? parseInt(assignmentData.passMarks) : ""
                const assignmentDescription = assignmentData.description.trim();
                const instID = UserService.getUserid();
                const courseId = parseInt(courseID)

                const tenantId = parseInt(tenantID)
                const assignmentID = assignmentData.assignID

                let date4 = moment(assignmentData.openDate).format();
                let date5 = moment(assignmentData.closeDate).format();



                let ReqBodyInfo = {
                    assignmentId: assignmentID,
                    name: assignmentName,
                    totalMarks: assignmentData.assignType === "marktype" ? totalMarks : 0,
                    passMarks: assignmentData.assignType === "marktype" ? passMarks : 0,
                    description: assignmentDescription,
                    openingDate: date4,
                    closingDate: date5,
                    createdBy: instID,
                    courseId: courseId,
                    tenantId: tenantId,
                    assignType: assignmentData.assignType,
                    mailstatus: assignmentData.mailstatus
                }


                AssignmentService.updateAssignmentDetail(ReqBodyInfo).then(res => {

                    setAssignmentData({
                        ...assignmentData,
                        steps: 2,
                        assignID: assignID,
                    })
                }).catch(err => {

                })
            }
            if (!assignmentData.updateAssignment) {


                const assignmentName = assignmentData.name.trim();
                const totalMarks = assignmentData.assignType === "marktype" ? parseInt(assignmentData.totalMarks) : ""
                const passMarks = assignmentData.assignType === "marktype" ? parseInt(assignmentData.passMarks) : ""
                const assignmentDescription = assignmentData.description.trim();
                const openingDateSplit = assignmentData.openDate.split("T");
                const closingDateSplit = assignmentData.closeDate.split("T");
                // const openingAssignDate = openingDateSplit[0] + "%20" + openingDateSplit[1] + "%3A00";
                // const closingAssignDate = closingDateSplit[0] + "%20" + closingDateSplit[1] + "%3A00";
                const openingAssignDatereplace = (assignmentData.openDate.replace("T", '%20')) + "%3A00"
                const openingAssignDate = openingAssignDatereplace.replace(':', '%3A00')
                const closingAssignDatereplace = (assignmentData.closeDate.replace('T', '%20')) + "%3A00"
                const closingAssignDate = closingAssignDatereplace.replace(':', '%3A00')

                // const openingAssignDate = assignmentData.openDate + " " + assignmentData.openTime + "%3A00"
                // const openAD1 = openingAssignDate.replace(':', '%3A');
                // const openAD = openAD1.replace(' ', '%20');
                // const closingAssignDate = assignmentData.closeDate + " " + assignmentData.closeTime + "%3A00"
                // const closeAD1 = closingAssignDate.replace(' ', '%20');
                // const closeAD = closeAD1.replace(' ', '%20');
                const instID = UserService.getUserid();
                const courseId = parseInt(courseID)
                const tenantId = parseInt(tenantID)

                let date4 = moment(assignmentData.openDate).format();
                let date5 = moment(assignmentData.closeDate).format();


                let ReqBodyInfoSave = {
                    name: assignmentName,
                    totalMarks: assignmentData.assignType === "marktype" ? totalMarks : 0,
                    passMarks: assignmentData.assignType === "marktype" ? passMarks : 0,
                    description: assignmentDescription,
                    openingDate: date4,
                    closingDate: date5,
                    createdBy: instID,
                    courseId: courseId,
                    tenantId: tenantId,
                    assignType: assignmentData.assignType,
                    mailstatus: assignmentData.mailstatus
                }



                AssignmentService.postAssignmentDetail(ReqBodyInfoSave).then(res => {

                    setAssignmentData({
                        ...assignmentData,
                        steps: 2,
                        assignID: res.data
                    })
                }).catch(err => {

                })
            }
        }
        const onClickSubmit = async () => {

            if (successMsg) {
                swal(t('success_swal'), swalMsg, 'success');
                setComp(
                    <>
                        <ViewAssignment />
                    </>
                )
            }
        }

        const onClickPrev = () => {
            setAssignmentData({
                ...assignmentData, steps: 1
            })
        }

        const toggleCreateAssignment = () => {
            setShowCreateAssignment(prevState => !prevState)
        }

        return (
            <>

                <Modal
                    centered
                    show={showCreateAssignment}
                    onHide={() => { toggleCreateAssignment(); onClickClose(); }}
                    size="xl"
                    backdrop="static"


                >
                    <Modal.Header closeButton>
                        <Modal.Title>Create Assignment</Modal.Title>
                    </Modal.Header>
                    <form>
                        <Modal.Body>
                            {/* <div>
                            
                            <h5>{t('create_assign')}</h5>
                        </div> */}

                            {/* <div>
                            <Row style={{ display: 'flex', justifyContent: 'space-between', margin: '0px 1px' }}>
                                <p>{t('fill_all_form')}</p>
                                <Button className='btn btn-danger' style={{ textAlign: 'right' }} onClick={onClickClose}> X </Button>
                            </Row>
                        </div> */}
                            {/* <br /> */}
                            <Container>

                                {/*Assignment step 1 Component is Called */}
                                <AssignStep1
                                    steps={assignmentData.steps}
                                    name={assignmentData.name}
                                    type={assignmentData.assignType}
                                    totalMarks={assignmentData.totalMarks}
                                    passMarks={assignmentData.passMarks}
                                    description={assignmentData.description}
                                    openDate={assignmentData.openDate}
                                    mailstatus={assignmentData.mailstatus}
                                    //openTime={assignmentData.openTime}
                                    closeDate={assignmentData.closeDate}
                                    //closeTime={assignmentData.closeTime}                            
                                    handleChange={handleChange}
                                    assignmentFormError={assignFormError}
                                    assignID={assignID}
                                />
                                {/*Assignment step 2 Component is Called */}
                                <AssignStep2
                                    steps={assignmentData.steps}
                                    assignID={assignmentData.assignID}
                                    setState={setSuccessMsg}
                                />

                            </Container>
                        </Modal.Body>
                        <Modal.Footer>
                            <div class="row justify-content-between">
                                {
                                    assignmentData.steps == 2
                                        ?
                                        <>
                                            <Row style={{ display: 'flex', justifyContent: 'space-between', margin: '0px 1px' }}>
                                                <Button onClick={onClickPrev} variant='light' style={{ marginRight: "5px" }}> {t('prev')} </Button>
                                                <Button onClick={onClickSubmit} variant='success'> {t('submit')} </Button>
                                            </Row>
                                        </>
                                        :
                                        <>
                                            <Button onClick={onClickNext} variant='light'>{t('next')} </Button>
                                        </>
                                }

                            </div>
                            <Button variant="danger" onClick={() => { toggleCreateAssignment(); onClickClose(); }}>
                                Close
                            </Button>
                        </Modal.Footer>
                    </form>
                </Modal>

            </>
        )
    }
    ////Assignment Step 1
    function AssignStep1(props) {

        const [getServerTime, setServerTime] = useState();
        useEffect(() => {
            instructorService.getServerTime()
                .then(res => {
                    let serTime = res.data;
                    setServerTime(serTime.replace(/\s/g, 'T'))
                })
        }, [])
        if (props.steps !== 1) {
            return null;
        }
        else {

            return (
                <>
                    <div className='card'>
                        <div className='card-body'>
                            <fieldset>
                                <div className='row'>
                                    <div className='col-md-4'>
                                        <p class="control-label">{t('assignment_name')}</p>
                                        <input type='text' className="form-control" minLength={2} maxLength={150} placeholder={t('enter_assign_name')} name='name' value={props.name} onChange={props.handleChange} />
                                        {
                                            props.assignmentFormError.nameError
                                                ?
                                                <>
                                                    <div className="alert alert-danger mt-2">{props.assignmentFormError.nameError}</div>
                                                </>
                                                :
                                                <>
                                                </>
                                        }
                                    </div>
                                    <div className='col-md-4'>
                                        <p class="control-label">Assignment Type</p>
                                        <select className="form-control" name='assignType' value={props.type} onChange={props.handleChange} >
                                            <option value="select" selected>Select Assignment type</option>
                                            <option value="reviewtype">Review Based</option>
                                            {/* <option value="marktype">Marks Based</option> */}
                                        </select>
                                        {
                                            props.assignmentFormError.assignTypeError
                                                ?
                                                <>
                                                    <div className="alert alert-danger mt-2">{props.assignmentFormError.assignTypeError}</div>
                                                </>
                                                :
                                                <>
                                                </>
                                        }
                                    </div>
                                    <div className='col-md-4'>
                                        <p class="control-label">Receive Student Assignment in E-Mail</p>
                                        <select className="form-control" name='mailstatus' value={props.mailstatus} onChange={props.handleChange} >
                                            <option value="select" selected>Select Mail Status</option>
                                            <option value="yes">Yes</option>
                                            <option value="no">No</option>
                                        </select>
                                        {
                                            props.assignmentFormError.mailstatusError
                                                ?
                                                <>
                                                    <div className="alert alert-danger mt-2">{props.assignmentFormError.mailstatusError}</div>
                                                </>
                                                :
                                                <>
                                                </>
                                        }
                                    </div>
                                </div>
                                <br />
                                {
                                    props.type === "marktype" ?
                                        <>
                                            <div class="row ">
                                                <div class="col-md-6">
                                                    <p class="control-label">{t('total_marks')}</p>
                                                    <input type='number' className="form-control" min={0} pattern="^[0-9]" placeholder={t('enter_total_marks')} name='totalMarks' value={props.totalMarks} onChange={props.handleChange} />
                                                    {
                                                        props.assignmentFormError.totalMarksError
                                                            ?
                                                            <>
                                                                <div className="alert alert-danger mt-2">{props.assignmentFormError.totalMarksError}</div>
                                                            </>
                                                            :
                                                            <>
                                                            </>
                                                    }

                                                </div>
                                                <div class="col-md-6">
                                                    <p class="control-label">{t('pass_marks')}</p>
                                                    <input type='number' className="form-control" min={1} pattern="^(?=.*[1-9])[0-9]+$" placeholder={t('enter_passing_marks')} name='passMarks' value={props.passMarks} onChange={props.handleChange} />
                                                    {
                                                        props.assignmentFormError.passMarksError
                                                            ?
                                                            <>
                                                                <div className="alert alert-danger mt-2">{props.assignmentFormError.passMarksError}</div>
                                                            </>
                                                            :
                                                            <>
                                                            </>
                                                    }
                                                </div>
                                            </div>
                                        </>
                                        :
                                        <>
                                        </>
                                }
                                <br />
                                <div className='row'>
                                    <div className='col-md-12'>
                                        <p class="control-label">{t('assign_desc')}</p>
                                        <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" minLength={2} maxLength={150}
                                            name='description' value={props.description} onChange={props.handleChange}></textarea>
                                        {
                                            props.assignmentFormError.descriptionError
                                                ?
                                                <>
                                                    <div className="alert alert-danger mt-2">{props.assignmentFormError.descriptionError}</div>
                                                </>
                                                :
                                                <>
                                                </>
                                        }
                                    </div>
                                </div>
                                <br />
                                <div class="row ">
                                    <div class="col col-md-6">
                                        <p class="control-label">{t('opening_date')}</p>
                                        <input type='datetime-local' className="form-control" name='openDate' value={props.openDate} onChange={props.handleChange} />
                                        {
                                            props.assignmentFormError.openDateError
                                                ?
                                                <>
                                                    <div className="alert alert-danger mt-2">{props.assignmentFormError.openDateError}</div>
                                                </>
                                                :
                                                <>
                                                </>
                                        }

                                    </div>
                                    <div class="col col-md-6">
                                        <p class="control-label">{t('close_date')}</p>
                                        <input type='datetime-local' className="form-control" name='closeDate' value={props.closeDate} onChange={props.handleChange} />
                                        {
                                            props.assignmentFormError.closeDateError
                                                ?
                                                <>
                                                    <div className="alert alert-danger mt-2">{props.assignmentFormError.closeDateError}</div>
                                                </>
                                                :
                                                <>
                                                </>
                                        }
                                    </div>
                                </div>
                                <br />
                            </fieldset>
                        </div>
                    </div>
                </>
            )
        }
    }



    ////Assignment Step 2 
    function AssignStep2(props) {
        const assignid = props.assignID;

        useEffect(() => {
            getAssignDetailById();

        }, [assignid])

        const [storeAssignDataById, setStoreAssignDataById] = useState();
        const [showUploadFile, setShowUploadFile] = useState(false);

        const getAssignDetailById = () => {
            AssignmentService.getAssignmentData(assignid).
                then((resp) => {
                    setStoreAssignDataById(resp.data.assignmentFilePath);

                }).catch((err) => {

                })
        }

        const [errorType, setErrorType] = useState();
        const [uploadFileCheck, setUploadFileCheck] = useState(false);
        const [selectedFiles, setSelectedFiles] = useState([])

        const selectFiles = (event) => {
            // event.preventDefault();
            // let fi = document.getElementById('file');
            let files = event.target.files;

            for (let i = 0; i < files.length; i++) {

                if (files[i].type != "application/pdf" && files[i].type != "application/x-pdf" && files[i].type != "application/x-zip-compressed") {
                    setErrorType(t('assign_upload_err'));
                    return;
                }
                else {
                    setUploadFileCheck(true)
                    setErrorType();
                    setSelectedFiles(files)
                }
            }
        }
        const onClickupload = async (e) => {

            e.preventDefault()
            // await fetchAndSetNonce("Assignment");
            if (uploadFileCheck == true) {
                setUploadFileCheck((prev) => !prev)
                for (let index = 0; index < selectedFiles.length; index++) {
                    const fileName = selectedFiles[index].name;
                    const validFileNamePattern = /^[a-zA-Z0-9()-._ ]+$/;

                    // alert(fileName)

                    if (!validFileNamePattern.test(fileName)) {
                        swal(t('error'), t('Invalid File name'), "error");
                        return;
                    }
                    const fileParts = fileName.split('.');
                    if (fileParts.length > 2) {
                        swal(t('error'), t('Double Extension file!'), "error");
                        return;
                    }


                    const form = new FormData();
                    form.append('file', selectedFiles[index]);
                    form.append('lengthHash', md5((selectedFiles[index].size).toString()))


                    AssignmentService.postFileUpload(props.assignID, form).then((res) => {


                        if (res.data === "InvalidFile") {
                            swal(t('error'), t('file_not_support'), "error");
                        }
                        else if (res.data === "double-extension-file") {
                            swal(t('error'), t('double-ext-file'), "error");
                        }
                        else {
                            swal(t('success'), t('file_upload_msg'), 'success');
                            getAssignDetailById();
                            document.getElementById('file').value = null;
                            props.setState("Success");
                            setUploadFileCheck(false)
                        }


                    }).catch((error) => {
                        // if(error.response.status === 406){
                        //     swal(t('error'),"File Not Supported","error");
                        // }

                    })
                }

                // document.getElementById('form').addEventListener('submit', function (e) {
                //     // e.preventDefault();

                //     // let fi = document.getElementById('file');
                //     // let files = fi.files;

                // })
            }
            else {

            }
        }


        /*This is For when instructor Click upload Button from Assignment List passes */
        /*uploadFileClick={true}
        steps={2}
        assignID={assignID}
        courseID={props.courseID}
        tenantID={props.tenantID} Line No 129  */

        const onClickBack = () => {
            setComp(<ViewAssignment />)
        }

        const toggleFileUpload = (state) => {
            setShowUploadFile((!state))
        }

        const [dispModel, setDispModal] = useState(false)
        const onHideClick = () => {
            setDispModal(false);
        }
        const [contentType, setContentType] = useState();
        const [file, setFile] = useState();
        const onClickView = (id) => {

            setFile(id);
            setDispModal(true)

        }
        const onClickDeleteFile = (id) => {
            AssignmentService.fileOnDelete(id).
                then((resp) => {
                    if (resp.status === 200) {
                        swal(t('success'), t('file_delete_msg'), 'success');
                        getAssignDetailById();
                        props.setState("Success");
                    }
                }).catch((err) => {

                })
        }
        const customStyles = {
            title: {
                style: {
                    fontColor: 'red',
                    fontWeight: '900',
                }
            },

            rows: {
                style: {
                    minHeight: '72px'
                },
            },

            headCells: {
                style: {

                    widthRight: '8px',
                    widthLeft: '8px',
                    // paddingLeft: '8px', // override the cell padding for head cells
                    // paddingRight: '8px',
                    fontSize: '17px',
                    // fontWeight: '500',
                    // textTransform: 'uppercase',
                    // paddingLeft: '0 8px',
                    // marginLeft: '10px',
                },
            },
            cells: {
                style: {
                    widthRight: '8px',
                    widthLeft: '8px',
                    // paddingLeft: '8px', // override the cell padding for data cells
                    // paddingRight: '8px',
                    fontSize: '15px',
                    // paddingLeft: '0 8px',
                    // marginLeft: '10px'
                },
            },
        };

        const fileUploadColumn = [
            {
                name: 'File Name',
                selector: row => row.filename,
            },
            {
                name: "Preview",
                cell: (row) =>
                    <>
                        <a className='link' href="#" onClick={() => { onClickView(row.id) }}>
                            {
                                row.filename.match(".zip")
                                    ?
                                    <>
                                        {setContentType(".zip")}
                                        <div onClick={() => { handleSaveFile(ASSIGN_URI._GET_FILE_TO_VIEW, row.filename, row.id) }}  ><i class="fas fa-file-archive" style={{ fontSize: "35px", color: "#fdbf00" }}></i></div>
                                    </>

                                    :
                                    row.filename.match(".pdf")
                                        ?
                                        <>
                                            {setContentType(".pdf")}
                                            {/* <a href={`${getFileToView}${row.id}`} >
                                                <i class="fas fa-file-pdf" style={{ fontSize: "35px", color: "#b30b00" }}></i>
                                            </a> */}
                                            <div onClick={() => { handleSaveFile(ASSIGN_URI._GET_FILE_TO_VIEW, row.filename, row.id) }} >
                                                <i class="fas fa-file-pdf" style={{ fontSize: "35px", color: "#b30b00" }}></i>
                                            </div>

                                        </>
                                        :
                                        row.filename.match(".doc") ||
                                            row.filename.match(".docx")
                                            ?
                                            <>
                                                {setContentType(".doc")}
                                                <div onClick={() => { handleSaveFile(ASSIGN_URI._GET_FILE_TO_VIEW, row.filename, row.id) }} target="_blank">
                                                    <i class="fas fa-file-word" style={{ fontSize: "35px", color: "#2596be" }}></i>
                                                </div>

                                            </>

                                            :
                                            <></>
                            }
                        </a>
                    </>
            },
            {
                name: 'Delete',
                selector: row =>
                    <>
                        <Button className='' variant='danger' onClick={() => { onClickDeleteFile(row.id) }}> <i class="fas fa-trash"></i> </Button>
                    </>


            }
        ]

        if (props.steps !== 2) {
            return null;
        }
        else {

            return (
                <>
                    {/* {//console.log(assignid)} */}

                    <div>
                        <h4 class="control-label" style={{ textAlign: 'center' }}> {t('upload_file')}</h4>
                        <p class="control-label" style={{ textAlign: 'center' }}>{t('file_pdf_doc_zip')}</p>
                        <br />
                        <form id='form'>
                            <div className='row'>
                                <div className='col-md-6 offset-md-3'>
                                    <input type='file' id='file' onChange={selectFiles} />
                                    {/* <div class="custom-file">
                                    <input type="file" class="custom-file-input" id="file"
                                        aria-describedby="inputGroupFileAddon01"
                                        onChange={selectFiles} />
                                    <label class="custom-file-label" for="inputGroupFile01">Choose file</label>
                                </div> */}
                                </div>
                                <button class="btn btn-primary" onClick={onClickupload} disabled={(!uploadFileCheck)}> {t('upload_file')}</button>
                            </div>
                            <div>
                                {errorType ? <div className="alert alert-danger mt-2">{errorType}</div> : <></>}
                            </div>
                        </form>
                        {
                            <>



                                {/* <div>
                                    {
                                        props.uploadFileClick == true ?
                                            <>
                                                <div>
                                                    <DataTable
                                                        columns={fileUploadColumn}
                                                        data={filteredAssignmentFile}
                                                        defaultSortField="Name"
                                                        defaultSortAsc={true}
                                                        striped
                                                        pagination
                                                        highlightOnHover
                                                        //customStyles={customStyles}
                                                        subHeader
                                                        subHeaderComponent={subHeaderComponent}
                                                        fixedHeader
                                                        fixedHeaderScrollHeight="300px"
                                                    />
                                                </div> 
                                            </>
                                            :
                                            <>
                                            </>
                                    }
                                </div> */}
                            </>
                        }
                    </div>
                    <br />
                    <br />
                    <div>
                        <DataTable
                            columns={fileUploadColumn}
                            data={storeAssignDataById}
                            customStyles={customStyles}
                        />
                    </div>
                    {/* <br /> */}
                    {/* {
                        props.uploadFileClick == true
                            ?
                            <>
                                <Button onClick={onClickBack} style={{ marginRight: "5px" }}> {t('back')} </Button>
                            </>
                            :
                            <>
                            </>
                    } */}
                    <Modal
                        centered
                        show={props.uploadFileClick}
                        onHide={onClickBack}
                        size="xl"
                        backdrop="static"


                    >
                        <Modal.Header closeButton>
                            <Modal.Title>Upload Files</Modal.Title>
                        </Modal.Header>
                        <form id='form'>
                            <Modal.Body>

                                <div>
                                    <h4 class="control-label" style={{ textAlign: 'center' }}> {t('upload_file')}</h4>
                                    <p class="control-label" style={{ textAlign: 'center' }}>{t('file_pdf_doc_zip')}</p>
                                    <br />

                                    <div className='row'>
                                        <div className='col-md-6 offset-md-3'>
                                            <input type='file' id='file' onChange={selectFiles} />
                                            {/* <div class="custom-file">
                                    <input type="file" class="custom-file-input" id="file"
                                        aria-describedby="inputGroupFileAddon01"
                                        onChange={selectFiles} />
                                    <label class="custom-file-label" for="inputGroupFile01">Choose file</label>
                                </div> */}
                                        </div>
                                        <button class="btn btn-primary" onClick={onClickupload} disabled={(!uploadFileCheck)}> {t('upload_file')}</button>
                                    </div>
                                    <div>
                                        {errorType ? <div className="alert alert-danger mt-2">{errorType}</div> : <></>}
                                    </div>

                                    {
                                        <>



                                            {/* <div>
                                    {
                                        props.uploadFileClick == true ?
                                            <>
                                                <div>
                                                    <DataTable
                                                        columns={fileUploadColumn}
                                                        data={filteredAssignmentFile}
                                                        defaultSortField="Name"
                                                        defaultSortAsc={true}
                                                        striped
                                                        pagination
                                                        highlightOnHover
                                                        //customStyles={customStyles}
                                                        subHeader
                                                        subHeaderComponent={subHeaderComponent}
                                                        fixedHeader
                                                        fixedHeaderScrollHeight="300px"
                                                    />
                                                </div> 
                                            </>
                                            :
                                            <>
                                            </>
                                    }
                                </div> */}
                                        </>
                                    }
                                </div>
                                <br />
                                <br />
                                <div>
                                    <DataTable
                                        columns={fileUploadColumn}
                                        data={storeAssignDataById}
                                        customStyles={customStyles}
                                    />
                                </div>


                            </Modal.Body>
                            <Modal.Footer>

                                <Button variant='light' onClick={onClickBack}> {t('back')} </Button>
                                <Button variant="danger" onClick={onClickBack}>
                                    Close
                                </Button>
                                {/* You can add additional buttons or actions here */}
                            </Modal.Footer>
                        </form>
                    </Modal>


                </>
            )
        }
    }


    /**************************************  EVALUATION COMPONENT ********************************/

    function Evaluation(props) {

        const courseID = props.courseID;
        const tenantID = props.tenantID;
        const assignID = props.assignID;
        const assignType = props.assignType;

        const toggleEvaluation = () => {
            setShowEvaluation(prevState => !prevState);
        }
        const [showEvaluation, setShowEvaluation] = useState(false);
        const [showLoading, setShowLoading] = useState(false);
        const [selectedAssignment, setSelectedAssignment] = useState({
            solID: null, assignId: null, courseID: null, tenantID: "", submittedBy: "", assignType: ""
        });
        const printRow = (row) => {

        }

        const [selectedRows, setSelectedRows] = useState([]);
        const [toggleCleared, setToggleCleared] = useState(false);
        const [extendedDuration, setExtendedDuration] = useState(0);
        const [filteredItems, setFilteredItems] = useState([]);
        const [selectedUsers, setSelectedUsers] = useState([]);

        const [loader, setLoader] = useState(false);
        const [errors, setErrors] = useState({});

        const handleRowSelected = useCallback(state => {
            // // console.log("CALLED");
            setSelectedRows(state.selectedRows);
        }, []);

        const transformSelectedData = () => {
            return selectedRows.map(row => ({
                userId: row.solution.submittedBy,  // submittedBy is userId
                solutionId: row.solution.solutionId, // solutionId remains the same
                extensionDays: extendedDuration // Use the state value
            }));
        };


        // // console.log("selectedRows ==> ", selectedRows);
        // // console.log("Transformed Data ==> ", transformSelectedData());

        const onDurationBlur = () => {
            const errors = {};
            if (isNaN(extendedDuration)) {
                errors.duration = "Duration must be a number";
            }
            setErrors(errors);
        }

        const onDurationChange = (duration) => {
            setExtendedDuration(duration);
        }

        const onSubmitButtonClick = () => {
            setLoader(true);
            if (Object.keys(errors).length !== 0) {
                swal("Warning", "Please Check the duration again", "warning")
            } else {
                const data = transformSelectedData();
                AssignmentService.updateUserAssignmentSubmissionDuration(data)
                    .then((res) => {
                        if (res.status === 200) {
                            swal("Success", "Successfully Updated the Dates", "success")
                        }
                    })
                    .catch((err) => {
                        swal("Error", "Internal Server Error! Contact Admin", "error");
                    })
                    .finally(() => {
                        setLoader(false);
                        setSelectedRows([]);
                        setExtendedDuration(0);
                        setToggleCleared(!toggleCleared);
                        assignmentSubmittedListAPI();
                    });
            }

        }

        const convertTimestampToDate = (timestamp) => {
            return moment(timestamp).format('Do MMMM YYYY');
        };

        const customStyles = {
            title: {
                style: {
                    fontColor: 'red',
                    fontWeight: '900',
                }
            },

            rows: {
                style: {
                    minHeight: '72px'
                },
            },

            headCells: {
                style: {

                    widthRight: '8px',
                    widthLeft: '8px',
                    // paddingLeft: '8px', // override the cell padding for head cells
                    // paddingRight: '8px',
                    fontSize: '17px',
                    // fontWeight: '500',
                    // textTransform: 'uppercase',
                    // paddingLeft: '0 8px',
                    // marginLeft: '10px',
                },
            },
            cells: {
                style: {
                    widthRight: '8px',
                    widthLeft: '8px',
                    // paddingLeft: '8px', // override the cell padding for data cells
                    // paddingRight: '8px',
                    fontSize: '15px',
                    // paddingLeft: '0 8px',
                    // marginLeft: '10px'
                },
            },
        };

        function onClickClose() {
            setComp(
                <>
                    <ViewAssignment />
                </>
            )
        }

        useEffect(() => {
            assignmentSubmittedListAPI();
        }, [])


        const [getAssignmentSubmittedList, setAssignmentSubmittedList] = useState([]);
        const [filterText, setFilterText] = React.useState("");
        const [resetPaginationToggle, setResetPaginationToggle] = React.useState(
            false
        );

        const [activeTab, setActiveTab] = useState('submitted');

        const assignmentSubmittedListAPI = async () => {
            setShowLoading(true);
            await AssignmentService.getAssignmentSubmittedList(courseID, tenantID, assignID)
                .then((resp) => {
                    setAssignmentSubmittedList(resp.data)
                    setShowLoading(false);
                }).catch((err) => {
                    setShowLoading(false);
                })
        }

        // const replicatedAssignments = Array.from({ length: 20 }, () => getAssignmentSubmittedList).flat();
        const submittedAssignments = getAssignmentSubmittedList.filter(
            item =>
                item.email?.toLowerCase().includes(filterText.toLowerCase()) &&
                item.solutionmarks?.status === "submitted"
        );

        const evaluatedAssignments = getAssignmentSubmittedList.filter(
            item =>
                item.email?.toLowerCase().includes(filterText.toLowerCase()) &&
                item.solutionmarks?.status === "approve"
        );

        const rejectedAssignments = getAssignmentSubmittedList.filter(
            item =>
                item.email?.toLowerCase().includes(filterText.toLowerCase()) &&
                (item.solutionmarks?.status === "reject" || item.solutionmarks?.status === "reupload")
        );

        const subHeaderComponent = useMemo(() => {
            const handleClear = () => {
                if (filterText) {
                    setResetPaginationToggle(!resetPaginationToggle);
                    setFilterText("");
                }
            };
            return (
                <FilterDataTable
                    onFilter={e => setFilterText(e.target.value)}
                    onClear={handleClear}
                    filterText={filterText}
                    placeholder={"Search By Email"}
                />
            );
        }, [filterText, resetPaginationToggle]);


        const columnViewSubmittedAssignment = assignType === "reviewType" ? [
            {
                name: 'Name',
                selector: row => row.name,
                sortable: true,
                wrap: true,

            },
            {
                name: 'Email',
                selector: row => row.email,
                sortable: true,
                wrap: true,

            },
            {
                name: 'Status',
                selector: row => row.solutionmarks.status,
            },
            {
                name: 'Score',
                selector: row => row.solutionmarks.marks,
                wrap: true
            },
            {
                name: 'Remarks',
                selector: row => row.solutionmarks.remarks,
                wrap: true,
            },
            {
                name: "Extended Date",
                selector: row => (row.solution.extensionCount > 0 ? convertTimestampToDate(row.solution.extensionDate) : "Not Extended"),
                wrap: true,
                sortable: true,
            },
            {
                name: "Total Extensions",
                selector: row => row.solution.extensionCount,
                sortable: true,
                wrap: true,
            },
            {
                name: 'Action',
                cell: row => <>
                    <div>
                        {props.userID === row.createdBy
                            ?
                            <>
                                {
                                    row.solutionmarks.status !== 'evaluated'
                                        ?
                                        <>
                                            <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">{t('evaluate')}</Tooltip>}>
                                                <button className='btn btn-success' style={{ marginLeft: '5px' }} onClick={() => { toggleEvaluation(); printRow(row); onClickEvalutionMarks(row.solution.assignmentId, row.solution.submittedBy, row.solution.solutionId); }} ><i class="fas fa-book-open"></i> </button>
                                                {/* style={activeAddModule ? {color: "white"} : {color:"#5cb85c"} */}
                                            </OverlayTrigger>

                                        </>
                                        :
                                        <>
                                            <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">{t('evaluate')}</Tooltip>}>
                                                <button className='btn btn-success' style={{ marginLeft: '5px' }} onClick={() => { onClickEvalutionMarks(row.solution.assignmentId, row.solution.submittedBy, row.solution.solutionId) }} disabled><i class="fas fa-book-open"></i> </button>
                                                {/* style={activeAddModule ? {color: "white"} : {color:"#5cb85c"} */}
                                            </OverlayTrigger>
                                        </>

                                }


                            </>
                            :
                            <>
                            </>
                        }
                    </div>
                </>
            }
        ] : [
            {
                name: 'Name',
                selector: row => row.name,
                sortable: true,
                wrap: true,

            },
            {
                name: 'Email',
                selector: row => row.email,
                sortable: true,
                wrap: true,

            },
            {
                name: 'Remarks',
                selector: row => row.solutionmarks.remarks,
                wrap: true,
            },
            {
                name: "Extended Date",
                selector: row => (row.solution.extensionCount > 0 ? convertTimestampToDate(row.solution.extensionDate) : "Not Extended"),
                wrap: true,
                sortable: true,
            },
            {
                name: "Total Extensions",
                selector: row => row.solution.extensionCount,
                sortable: true,
                wrap: true,
            },
            {
                name: 'Action',
                cell: row => <>
                    <div>
                        {props.userID === row.createdBy
                            ?
                            <>
                                {
                                    // row.solutionmarks.status !== 'evaluated' || 
                                    row.solutionmarks.status == 'approve'
                                        ?
                                        <>
                                            <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">{t('evaluate')}</Tooltip>}>
                                                <button className='btn btn-success' style={{ marginLeft: '5px' }} onClick={() => { onClickEvalutionMarks(row.solution.assignmentId, row.solution.submittedBy, row.solution.solutionId) }} disabled><i class="fas fa-book-open"></i> </button>
                                                {/* style={activeAddModule ? {color: "white"} : {color:"#5cb85c"} */}
                                            </OverlayTrigger>

                                        </>
                                        :
                                        <>
                                            {
                                                row.solutionmarks.status === 'evaluated' ?
                                                    <>
                                                        <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">{t('evaluate')}</Tooltip>}>
                                                            <button className='btn btn-success' style={{ marginLeft: '5px' }} onClick={() => { onClickEvalutionMarks(row.solution.assignmentId, row.solution.submittedBy, row.solution.solutionId) }} disabled><i class="fas fa-book-open"></i> </button>
                                                            {/* style={activeAddModule ? {color: "white"} : {color:"#5cb85c"} */}
                                                        </OverlayTrigger>
                                                    </>
                                                    :
                                                    <>
                                                        <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">{t('evaluate')}</Tooltip>}>
                                                            <button className='btn btn-success' style={{ marginLeft: '5px' }} onClick={() => { toggleEvaluation(); printRow(row); onClickEvalutionMarks(row.solution.assignmentId, row.solution.submittedBy, row.solution.solutionId); }} ><i class="fas fa-book-open"></i> </button>
                                                            {/* style={activeAddModule ? {color: "white"} : {color:"#5cb85c"} */}
                                                        </OverlayTrigger>
                                                    </>
                                            }
                                        </>

                                }


                            </>
                            :
                            <>
                            </>
                        }
                    </div>
                </>
            }]

        const columnViewRejectedAssignment = assignType === "reviewType" ? [
            {
                name: 'Name',
                selector: row => row.name,
                sortable: true,
                wrap: true,

            },
            {
                name: 'Email',
                selector: row => row.email,
                sortable: true,
                wrap: true,

            },
            {
                name: 'Status',
                selector: row => row.solutionmarks.status,
            },
            {
                name: 'Score',
                selector: row => row.solutionmarks.marks,
                wrap: true
            },
            {
                name: 'Remarks',
                selector: row => row.solutionmarks.remarks,
                wrap: true,
            },
            {
                name: "Extended Date",
                selector: row => (row.solution.extensionCount > 0 ? convertTimestampToDate(row.solution.extensionDate) : "Not Extended"),
                wrap: true,
                sortable: true,
            },
            {
                name: "Total Extensions",
                selector: row => row.solution.extensionCount,
                sortable: true,
                wrap: true,
            },
            {
                name: 'Action',
                cell: row => <>
                    <div>
                        {props.userID === row.createdBy
                            ?
                            <>
                                {
                                    row.solutionmarks.status !== 'evaluated'
                                        ?
                                        <>
                                            <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">{t('evaluate')}</Tooltip>}>
                                                <button className='btn btn-success' style={{ marginLeft: '5px' }} onClick={() => { toggleEvaluation(); printRow(row); onClickEvalutionMarks(row.solution.assignmentId, row.solution.submittedBy, row.solution.solutionId); }} ><i class="fas fa-book-open"></i> </button>
                                                {/* style={activeAddModule ? {color: "white"} : {color:"#5cb85c"} */}
                                            </OverlayTrigger>

                                        </>
                                        :
                                        <>
                                            <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">{t('evaluate')}</Tooltip>}>
                                                <button className='btn btn-success' style={{ marginLeft: '5px' }} onClick={() => { onClickEvalutionMarks(row.solution.assignmentId, row.solution.submittedBy, row.solution.solutionId) }} disabled><i class="fas fa-book-open"></i> </button>
                                                {/* style={activeAddModule ? {color: "white"} : {color:"#5cb85c"} */}
                                            </OverlayTrigger>
                                        </>

                                }


                            </>
                            :
                            <>
                            </>
                        }
                    </div>
                </>
            }
        ] : [
            {
                name: 'Name',
                selector: row => row.name,
                sortable: true,
                wrap: true,

            },
            {
                name: 'Email',
                selector: row => row.email,
                sortable: true,
                wrap: true,

            },
            {
                name: 'Remarks',
                selector: row => row.solutionmarks.remarks,
                wrap: true,
            },
            {
                name: "Extended Date",
                selector: row => convertTimestampToDate(row.solution.extensionDate),
                wrap: true,
                sortable: true,
            },
            {
                name: "Total Extensions",
                selector: row => row.solution.extensionCount,
                sortable: true,
                wrap: true,
            },
            {
                name: 'Action',
                cell: row => <>
                    <div>
                        {props.userID === row.createdBy
                            ?
                            <>
                                {
                                    // row.solutionmarks.status !== 'evaluated' || 
                                    row.solutionmarks.status == 'approve'
                                        ?
                                        <>
                                            <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">{t('evaluate')}</Tooltip>}>
                                                <button className='btn btn-success' style={{ marginLeft: '5px' }} onClick={() => { onClickEvalutionMarks(row.solution.assignmentId, row.solution.submittedBy, row.solution.solutionId) }} disabled><i class="fas fa-book-open"></i> </button>
                                                {/* style={activeAddModule ? {color: "white"} : {color:"#5cb85c"} */}
                                            </OverlayTrigger>

                                        </>
                                        :
                                        <>
                                            {
                                                row.solutionmarks.status === 'evaluated' ?
                                                    <>
                                                        <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">{t('evaluate')}</Tooltip>}>
                                                            <button className='btn btn-success' style={{ marginLeft: '5px' }} onClick={() => { onClickEvalutionMarks(row.solution.assignmentId, row.solution.submittedBy, row.solution.solutionId) }} disabled><i class="fas fa-book-open"></i> </button>
                                                            {/* style={activeAddModule ? {color: "white"} : {color:"#5cb85c"} */}
                                                        </OverlayTrigger>
                                                    </>
                                                    :
                                                    <>
                                                        <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">{t('evaluate')}</Tooltip>}>
                                                            <button className='btn btn-success' style={{ marginLeft: '5px' }} onClick={() => { toggleEvaluation(); printRow(row); onClickEvalutionMarks(row.solution.assignmentId, row.solution.submittedBy, row.solution.solutionId); }} ><i class="fas fa-book-open"></i> </button>
                                                            {/* style={activeAddModule ? {color: "white"} : {color:"#5cb85c"} */}
                                                        </OverlayTrigger>
                                                    </>
                                            }
                                        </>

                                }


                            </>
                            :
                            <>
                            </>
                        }
                    </div>
                </>
            }]

        function onClickEvalutionMarks(assignId, submittedBy, solID) {

            setSelectedAssignment({ solID, assignId, courseID, tenantID, submittedBy, assignType });

        }

        return (
            <>
                <Modal
                    centered
                    show={true}
                    onHide={onClickClose}
                    // size="xl"
                    fullscreen={true}
                    backdrop="static"
                // style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh", width: "90vw" }}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>{t('evaluation')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className='modal-main-body'
                            style={{ minHeight: "85vh" }}
                        >
                            {
                                showEvaluation ?
                                    <Container>
                                        <EvaluationMarks {...selectedAssignment} />
                                    </Container>
                                    :
                                    <>
                                        {
                                            showLoading ?
                                                <>
                                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
                                                        <Bars height={40} width={40} color="#0C122Fff" ariaLabel="circles-loading" />
                                                    </div>
                                                </>
                                                :
                                                <>

                                                    <Tabs
                                                        id="assignment-tabs"
                                                        activeKey={activeTab}
                                                        onSelect={(k) => setActiveTab(k)}
                                                        className="mb-3"
                                                    >
                                                        <Tab eventKey="submitted" title="Submitted Assignments">
                                                            <Card>
                                                                <DataTable
                                                                    columns={columnViewSubmittedAssignment}
                                                                    data={submittedAssignments}
                                                                    defaultSortField="Name"
                                                                    defaultSortAsc={true}
                                                                    striped
                                                                    pagination
                                                                    highlightOnHover
                                                                    customStyles={customStyles}
                                                                    subHeader
                                                                    subHeaderComponent={subHeaderComponent}
                                                                    fixedHeader
                                                                    fixedHeaderScrollHeight="70vh" // Ensure it takes full height of the container
                                                                />
                                                            </Card>
                                                        </Tab>

                                                        <Tab eventKey="evaluated" title="Evaluated Assignments">
                                                            <Card>
                                                                <DataTable
                                                                    columns={columnViewSubmittedAssignment}
                                                                    data={evaluatedAssignments}
                                                                    defaultSortField="Name"
                                                                    defaultSortAsc={true}
                                                                    striped
                                                                    pagination
                                                                    highlightOnHover
                                                                    customStyles={customStyles}
                                                                    subHeader
                                                                    subHeaderComponent={subHeaderComponent}
                                                                    fixedHeader
                                                                    fixedHeaderScrollHeight="70vh"
                                                                />
                                                            </Card>
                                                        </Tab>

                                                        {/* <Tab eventKey="rejected" title="Rejected Assignments">
                                                            <Card>
                                                                <DataTable
                                                                    columns={columnViewSubmittedAssignment}
                                                                    data={rejectedAssignments}
                                                                    defaultSortField="Name"
                                                                    defaultSortAsc={true}
                                                                    striped
                                                                    pagination
                                                                    highlightOnHover
                                                                    customStyles={customStyles}
                                                                    subHeader
                                                                    subHeaderComponent={subHeaderComponent}
                                                                    fixedHeader
                                                                    fixedHeaderScrollHeight="70vh"
                                                                    selectableRows
                                                                    onSelectedRowsChange={handleRowSelected}
                                                                    clearSelectedRows={toggleCleared}
                                                                />
                                                            </Card>
                                                        </Tab> */}
                                                        <Tab eventKey="rejected" title="Rejected Assignments">
                                                            <Card>
                                                                <Row style={{ marginBottom: "30px", padding: "20px" }}>
                                                                    <Col md={8}>
                                                                        <div className='input-area-duration'>
                                                                            <label className='label-duration'>
                                                                                Assignment Resubmission Extend (in Days):
                                                                                <OverlayTrigger
                                                                                    overlay={
                                                                                        <Tooltip id="tooltip-d isabled">
                                                                                            Enter the Duration (in Days) by which you want to extend the Assignment Submission deadline for User(s)
                                                                                        </Tooltip>
                                                                                    }
                                                                                >
                                                                                    <i className="fa fa-info-circle" style={{ fontSize: '18px', marginLeft: "5px" }}></i>
                                                                                </OverlayTrigger>
                                                                            </label>
                                                                            <input
                                                                                type="number"
                                                                                className="extendedDuration-form"
                                                                                value={extendedDuration}
                                                                                onChange={(e) => onDurationChange(e.target.value)}
                                                                                onBlur={() => onDurationBlur()}
                                                                                placeholder="Enter Duration in Days"
                                                                            />
                                                                            {errors?.duration && <span className="error-message">{errors?.duration}</span>}
                                                                        </div>
                                                                    </Col>
                                                                    <Col md={4}>
                                                                        <div className='submit-button-area d-flex justify-content-end'>
                                                                            <Button
                                                                                size='lg'
                                                                                className='submit-button mr-2 btn-success'
                                                                                onClick={onSubmitButtonClick}
                                                                                disabled={!(selectedRows?.length > 0)}
                                                                            >
                                                                                Submit
                                                                            </Button>
                                                                        </div>
                                                                    </Col>
                                                                </Row>

                                                                {
                                                                    (loader === true) && (
                                                                        <div style={{
                                                                            position: 'absolute',
                                                                            // top: 0,
                                                                            left: 0,
                                                                            right: 0,
                                                                            bottom: 0,
                                                                            display: 'flex',
                                                                            justifyContent: 'center',
                                                                            alignItems: 'center',
                                                                            backgroundColor: 'rgba(255, 255, 255, 0.4)',
                                                                            zIndex: 9999,
                                                                            // height: "150vh"
                                                                        }}>
                                                                            <div>
                                                                                <Bars height={40} width={40} color="#0C122Fff" ariaLabel="circles-loading" />
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                }

                                                                <DataTable
                                                                    columns={columnViewRejectedAssignment}
                                                                    data={rejectedAssignments}
                                                                    defaultSortField="Name"
                                                                    defaultSortAsc={true}
                                                                    striped
                                                                    pagination
                                                                    highlightOnHover
                                                                    customStyles={customStyles}
                                                                    subHeader
                                                                    subHeaderComponent={subHeaderComponent}
                                                                    fixedHeader
                                                                    fixedHeaderScrollHeight="70vh"
                                                                    selectableRows
                                                                    onSelectedRowsChange={handleRowSelected}
                                                                    clearSelectedRows={toggleCleared}
                                                                />
                                                            </Card>
                                                        </Tab>

                                                    </Tabs>
                                                </>
                                        }
                                    </>
                            }

                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        {
                            showEvaluation &&

                            <>
                                {/* <Button variant="success"> {t('submit')} </Button> */}
                                <Button variant="light" onClick={toggleEvaluation}>
                                    Back
                                </Button>
                            </>


                        }

                        <Button variant="danger" onClick={onClickClose}>
                            Close
                        </Button>
                    </Modal.Footer>

                </Modal >
            </>
        );
    }



    ////Evaluation Marks
    function EvaluationMarks(props) {
        const currentLanguageCode = cookies.get('i18next') || 'en'
        const currentLanguage = languages.find((l) => l.code === currentLanguageCode)
        const { t } = useTranslation()
        const assignType = props.assignType;


        useEffect(() => {
             document.body.dir = currentLanguage?.dir ?? "ltr";
            document.title = t('app_title')
        }, [currentLanguage, t])
        const { solID, assignId, tenantID, courseID, submittedBy } = props;

        const userID = UserService.getUserid();

        useEffect(() => {
            getStudentFile();
        }, [])

        const [extendDuration, setExtendDuration] = useState(0);
        const [extensioDate, setExtensioDate] = useState(null);
        const [errors, setErrors] = useState({});

        const formatDate = (date) => {
            return moment(date).format('YYYY-MM-DD');
        };

        const [solStudFile, setSolStudFile] = useState([])
        const getStudentFile = () => {
            AssignmentService.getStudentFileUpload(assignId, submittedBy).then((resp) => {

                if (resp.status === 200) {
                    setSolStudFile(resp.data)
                    const baseDate = resp.data.solution.extensionCount > 0
                        ? moment(resp.data.solution.extensionDate) // Use extensionDate if extensionCount > 0
                        : moment(); // Use current date otherwise

                    setExtensioDate(formatDate(baseDate));
                }
            }).catch((err) => {

            })
        }

        const onDurationChange = (duration) => {
            setExtendDuration(duration);
            const baseDate = solStudFile.solution.extensionCount > 0
                ? moment(solStudFile.solution.extensionDate)  // Use extensionDate if extensionCount > 0
                : moment(); // Use current date otherwise

            setExtensioDate(formatDate(baseDate.add(duration, 'days')));
        }

        const onDurationBlur = () => {
            const errors = {};
            if (isNaN(extendDuration)) {
                errors.duration = "Duration must be a number";
            }
            setErrors(errors);
        }



        const customStyles = {
            title: {
                style: {
                    fontColor: 'red',
                    fontWeight: '900',
                }
            },

            rows: {
                style: {
                    minHeight: '72px'
                },
            },

            headCells: {
                style: {

                    widthRight: '8px',
                    widthLeft: '8px',
                    // paddingLeft: '8px', // override the cell padding for head cells
                    // paddingRight: '8px',
                    fontSize: '17px',
                    // fontWeight: '500',
                    // textTransform: 'uppercase',
                    // paddingLeft: '0 8px',
                    // marginLeft: '10px',
                },
            },
            cells: {
                style: {
                    widthRight: '8px',
                    widthLeft: '8px',
                    // paddingLeft: '8px', // override the cell padding for data cells
                    // paddingRight: '8px',
                    fontSize: '15px',
                    // paddingLeft: '0 8px',
                    // marginLeft: '10px'
                },
            },
        };

        const resetEvalutionMarks = () => {
            setEvaluationMarks((prev) => {
                return {
                    ...prev,
                    marks: "",
                    remarks: "",
                    row: "",
                    showRejectModal: false
                }
            })

            setEvaluationMarksError((prev) => {
                return {
                    ...prev,
                    marksError: "",
                    remarksError: ""
                }
            })
        }

        const approveAssignment = (row) => {

            const data = {
                remark: ""
            }
            Swal.fire({
                title: "Confirmation",
                text: "Once approved it cannot be rejected Later",
                icon: "info",
                showConfirmButton: true,
                showCloseButton: true,
            }).then(resp => {
                if (resp.isConfirmed) {
                    Swal.fire({
                        title: "Please Wait",
                        showCancelButton: false,
                        showCloseButton: false,
                        showConfirmButton: false,
                        didOpen: () => {
                            Swal.showLoading();
                            AssignmentService.approveAssignment(row?.sno, data).then((res) => {
                                if (res.status === 200) {
                                    Swal.fire({
                                        title: "Success",
                                        text: "Assignment Approve Successfully",
                                        icon: "success",
                                        showConfirmButton: false,
                                        showCloseButton: false,
                                        showCancelButton: false
                                    })
                                    resetEvalutionMarks();
                                    getStudentFile();

                                }
                            }).catch((error) => {
                                Swal.fire({
                                    title: "Error",
                                    text: "Something went wrong",
                                    icon: "error",
                                    showConfirmButton: false,
                                    showCloseButton: false,
                                    showCancelButton: false
                                })
                                resetEvalutionMarks();


                            })
                        }
                    })
                }
            })
        }

        const submitRejectAssignmentWithRemarks = () => {
            const status = ValidateForm();
            if (evaluationMarks.remarks == "" || extendDuration === "" || extendDuration === 0 || extendDuration === null) {
                Swal.fire({
                    title: "Warning",
                    text: "Remarks and extend duration can not be Empty",
                    icon: "warning",
                })
            }

            const data = {
                remarks: evaluationMarks.remarks,
                duration: extendDuration
            }

            if (status) {

                Swal.fire({
                    title: "Please Wait",
                    showCancelButton: false,
                    showCloseButton: false,
                    showConfirmButton: false,
                    didOpen: () => {
                        Swal.showLoading();
                        AssignmentService.rejectAssignment(evaluationMarks.row?.sno, data).then((res) => {
                            if (res.status === 200) {
                                Swal.fire({
                                    title: "Success",
                                    text: "Assignment Reject Successfully",
                                    icon: "success",
                                    showConfirmButton: false,
                                    showCloseButton: false,
                                    showCancelButton: false
                                })
                                getStudentFile();
                                resetEvalutionMarks();


                            }
                        }).catch((error) => {
                            Swal.fire({
                                title: "Error",
                                text: "Something went wrong",
                                icon: "error",
                                showConfirmButton: false,
                                showCloseButton: false,
                                showCancelButton: false
                            })
                            getStudentFile();
                            resetEvalutionMarks();

                        })
                    }
                })
            }
        }

        const rejectAssignment = (row) => {
            setEvaluationMarks((prev) => {
                return {
                    ...prev,
                    showRejectModal: true,
                    row: row
                }
            })
        }

        const studfileColumn = [
            {
                name: 'File Name',
                selector: row => row.filename,
            },
            {
                name: "Preview",
                cell: (row) =>
                    <>

                        <a className='link' href="#" >
                            {
                                row.filename.match(".zip")
                                    ?
                                    <>

                                        <div onClick={() => { handlePreviewFile(ASSIGN_URI._PREVIEW_STUDENT_FILE, row.filename, row.sno) }}  ><i class="fas fa-file-archive" style={{ fontSize: "35px", color: "#fdbf00" }}></i></div>
                                    </>

                                    :
                                    row.filename.match(".pdf")
                                        ?
                                        <>

                                            <div onClick={() => { handlePreviewFile(ASSIGN_URI._PREVIEW_STUDENT_FILE, row.filename, row.sno) }} style={{ cursor: "pointer" }}>
                                                <i class="fas fa-file-pdf" style={{ fontSize: "35px", color: "#b30b00" }}></i>
                                            </div>

                                        </>
                                        :
                                        row.filename.match(".doc") ||
                                            row.filename.match(".docx")
                                            ?
                                            <>

                                                <div onClick={() => { handlePreviewFile(ASSIGN_URI._PREVIEW_STUDENT_FILE, row.filename, row.sno) }} target="_blank">
                                                    <i class="fas fa-file-word" style={{ fontSize: "35px", color: "#2596be" }}></i>
                                                </div>
                                            </>
                                            :
                                            <></>
                            }
                        </a>
                    </>
            },
            {
                name: "Download",
                cell: (row) =>
                    <>

                        <a className='link' href="#" >
                            {
                                row.filename.match(".zip")
                                    ?
                                    <>

                                        <div onClick={() => { handleSaveFile(ASSIGN_URI._GET_STUDENT_FILE, row.filename, row.sno) }}  ><i class="fas fa-file-archive" style={{ fontSize: "35px", color: "#fdbf00" }}></i></div>
                                    </>

                                    :
                                    row.filename.match(".pdf")
                                        ?
                                        <>

                                            <div onClick={() => { handleSaveFile(ASSIGN_URI._GET_STUDENT_FILE, row.filename, row.sno) }} style={{ cursor: "pointer" }}>
                                                <i class="fas fa-file-pdf" style={{ fontSize: "35px", color: "#b30b00" }}></i>
                                            </div>

                                        </>
                                        :
                                        row.filename.match(".doc") ||
                                            row.filename.match(".docx")
                                            ?
                                            <>

                                                <div onClick={() => { handleSaveFile(ASSIGN_URI._GET_STUDENT_FILE, row.filename, row.sno) }} target="_blank">
                                                    <i class="fas fa-file-word" style={{ fontSize: "35px", color: "#2596be" }}></i>
                                                </div>
                                            </>
                                            :
                                            <></>
                            }
                        </a>
                    </>
            },

            {
                name: assignType === "reviewtype" ? "Action" : "",
                cell: assignType === "reviewtype" ? (row) =>
                    <>
                        {
                            row?.status === "submitted" ?
                                <>
                                    <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">Approve</Tooltip>}>
                                        <button type="button" onClick={() => {
                                            approveAssignment(row)
                                        }} class="btn m-2" style={{ background: "green", color: "white" }}><i class="fa fa-thumbs-up"></i></button>
                                    </OverlayTrigger>
                                    <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">Resubmit</Tooltip>}>
                                        <button type="button" onClick={() => {
                                            rejectAssignment(row)
                                        }} class="btn btn-danger m-2" > <i class="fa fa-thumbs-down"></i></button>
                                    </OverlayTrigger>
                                </>
                                :
                                <>
                                    {
                                        row?.status === "approve" ?
                                            <>
                                                <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">Approve</Tooltip>}>
                                                    <button disabled type="button" onClick={() => {
                                                        approveAssignment(row)
                                                    }} class="btn m-2" style={{ background: "green", color: "white" }}><i class="fa fa-thumbs-up"></i></button>
                                                </OverlayTrigger>
                                            </>
                                            :
                                            <>
                                                {
                                                    row?.status === "reject" ?
                                                        <>
                                                            <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">Resubmit</Tooltip>}>
                                                                <button disabled type="button" onClick={() => {
                                                                    rejectAssignment(row)
                                                                }} class="btn btn-danger m-2" > <i class="fa fa-thumbs-down"></i></button>
                                                            </OverlayTrigger>
                                                        </>
                                                        :
                                                        <>
                                                        </>
                                                }
                                            </>
                                    }
                                </>
                        }
                    </>
                    : ""
            },
        ]



        const [evaluationMarks, setEvaluationMarks] = useState({
            showRejectModal: false,
            marks: '',
            remarks: '',
            row: "",
        });
        const [evaluationMarksError, setEvaluationMarksError] = useState({
            marksError: '',
            remarksError: '',
        })

        const marksHandler = (event) => {
            setEvaluationMarks({
                ...evaluationMarks,
                [event.target.name]: event.target.value
            })
        }

        function ValidateForm() {
            let marksE = '';
            let remarksE = '';

            if (assignType === "reviewtype") {
                if (evaluationMarks.remarks == '') {
                    remarksE = t('field_required')
                }
                if (!evaluationMarks.remarks.match(/^[A-Za-z0-9()&.,\"\'\\s ]+$/)) {
                    remarksE = "AlphaNumeric with ( ) & . , - \" \' and Space are Allowed "
                }
                if ((remarksE != '' || !evaluationMarks.remarks.match(/^[A-Za-z0-9()&.,\"\'\\s ]+$/))) {
                    setEvaluationMarksError({
                        ...evaluationMarksError,
                        remarksError: remarksE,
                    })
                    return false;
                }
                return true
            }
            else {
                if (evaluationMarks.marks == '') {
                    marksE = t('field_required')
                }
                if (evaluationMarks.remarks == '') {
                    remarksE = t('field_required')
                }
                if (!evaluationMarks.remarks.match(/^[A-Za-z0-9()&.,\"\'\\s ]+$/)) {
                    remarksE = "AlphaNumeric with ( ) & . , - \" \' and Space are Allowed "
                }
                if (marksE != '' && (remarksE != '' || !evaluationMarks.remarks.match(/^[A-Za-z0-9()&.,\"\'\\s ]+$/))) {
                    setEvaluationMarksError({
                        ...evaluationMarksError,
                        marksError: marksE,
                        remarksError: remarksE,
                    })
                    return false;
                }
                return true
            }
        }

        async function onClickSubmit() {
            const check = ValidateForm();
            // await fetchAndSetNonce("Assignment");
            if (check == true) {

                swal({
                    title: t('swal_title'),
                    text: t('evaluation_msg'),
                    icon: "warning",
                    buttons: true,
                    dangerMode: true,
                })
                    .then((Ok) => {
                        if (Ok) {

                            let evalBody = {
                                solution_id: solID,
                                marks: evaluationMarks.marks,
                                remarks: evaluationMarks.remarks,
                                evaluatedBy: userID
                            }


                            AssignmentService.putEvaluatedBy(evalBody).then((resp) => {
                                if (resp.status == 200) {
                                    swal(t('evaluate_success'), {
                                        icon: "success",
                                    });
                                    // setComp(
                                    //     <>
                                    //         <Evaluation
                                    //             courseID={courseID}
                                    //             tenantID={tenantID}
                                    //             assignID={assignId}
                                    //         />
                                    //     </>
                                    // )
                                    setComp(
                                        <>
                                            <ViewAssignment />
                                        </>
                                    )
                                }
                            })
                        }
                        // else {
                        //     swal("Your imaginary file is safe!");
                        // }
                    });
            }
        }

        function onClickCloseButton() {
            setComp(
                <>
                    <Evaluation
                        assignID={assignId}
                        tenantID={tenantID}
                        courseID={courseID}
                    />
                </>
            )
        }


        return (
            <>
                <fieldset>
                    <div style={{ textAlign: 'center' }}>
                        {/* {//console.log(solStudFile)} */}
                        <DataTable
                            columns={studfileColumn}
                            customStyles={customStyles}
                            data={solStudFile.solutionfile}
                            defaultSortAsc={true}
                            striped
                            highlightOnHover
                            subHeader
                            fixedHeader
                        />
                    </div>
                    <br />
                    <br />
                    <div>
                        {
                            assignType === "reviewtype" ?
                                <>
                                </>
                                :
                                <>
                                    <form>

                                        <div className='row' style={{ marginLeft: '1px' }}>
                                            <p class="control-label" style={{ marginRight: '20px' }}>{t('mark')} </p>
                                            <input type='number' min={0} pattern="^[0-9]" placeholder="Enter Marks " name='marks' value={evaluationMarks.marks} onChange={marksHandler} />
                                        </div>
                                        <div>
                                            {
                                                evaluationMarksError.marksError
                                                    ?
                                                    <>
                                                        <div className="alert alert-danger mt-2">{evaluationMarksError.marksError}</div>
                                                    </>
                                                    :
                                                    <>
                                                    </>
                                            }
                                        </div>


                                        <br />
                                        <div className='row' style={{ marginLeft: '1px' }}>
                                            <p class="control-label">{t('remarks')}</p>
                                            <textarea class="form-control" style={{ marginRight: '1px' }} id="exampleFormControlTextarea1" rows="3"
                                                name='remarks' minLength={2} maxLength={150} value={evaluationMarks.remarks} onChange={marksHandler}></textarea>
                                        </div>
                                        {
                                            evaluationMarksError.remarksError
                                                ?
                                                <>
                                                    <div className="alert alert-danger mt-2">{evaluationMarksError.remarksError}</div>
                                                </>
                                                :
                                                <>
                                                </>
                                        }
                                    </form>
                                    <br />
                                    <br />
                                    <Row style={{ display: 'flex', margin: '0px 1px' }}>
                                        <Button variant='success' onClick={onClickSubmit}> {t('submit')} </Button>
                                    </Row>
                                </>
                        }
                    </div>
                </fieldset>

                <Modal
                    size='lg'
                    centered
                    backdrop="static"
                    show={evaluationMarks.showRejectModal}
                    onHide={() => setEvaluationMarks((prev) => ({ ...prev, showRejectModal: false, marks: '', remarks: '', row: '' }))}>
                    <Modal.Header>
                        <h5>Please provide remarks</h5>
                    </Modal.Header>
                    <Modal.Body>
                        <div style={{ margin: '0px', width: '100%' }}>
                            <p style={{ fontSize: '15px', fontWeight: '500' }}>Remarks:</p>
                            <textarea
                                className="form-control"
                                placeholder='Remarks is Mandatory'
                                name='remarks'
                                minLength={2}
                                maxLength={150}
                                value={evaluationMarks.remarks}
                                onChange={marksHandler}
                            />
                            <br />

                            <p style={{ fontSize: '14px', color: '#6c757d', marginTop: '5px' }}>
                                Enter the Duration (in Days) till which you want to extend the resubmission of the assignment:
                            </p>

                            <div
                                style={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: '10px',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                }}
                            >
                                <input
                                    type="number"
                                    className="form-control"
                                    style={{
                                        flex: '1',
                                        minWidth: '150px', // Ensures proper spacing on smaller screens
                                    }}
                                    value={extendDuration}
                                    onChange={(e) => onDurationChange(e.target.value)}
                                    onBlur={() => onDurationBlur()}
                                    placeholder="Enter the Days to extend"
                                    min={0}
                                />

                                <input
                                    type="date"
                                    className="form-control"
                                    style={{
                                        flex: '1',
                                        minWidth: '150px', // Ensures proper spacing on smaller screens
                                    }}
                                    value={formatDate(extensioDate)}
                                    disabled={true}
                                />
                            </div>

                            {errors?.duration && <span className="error-message">{errors?.duration}</span>}

                            <p style={{ fontSize: '14px', color: '#6c757d', marginTop: '5px' }}>
                                Once you have selected Resubmit, you cannot evaluate the assignment again unless the learner uploads a new assignment.
                            </p>
                        </div>

                        {evaluationMarksError.remarksError && <div className="alert alert-danger mt-2">{evaluationMarksError.remarksError}</div>}
                        {/* <CourseDurationUpdate /> */}
                        <div style={{ display: 'flex', margin: '15px 0px' }}>
                            <Button
                                variant='success'
                                onClick={submitRejectAssignmentWithRemarks}
                            >
                                Submit
                            </Button>
                            <Button
                                variant='danger'
                                style={{ marginLeft: '5px' }}
                                onClick={() => setEvaluationMarks((prev) => ({ ...prev, marks: '', remarks: '', row: '', showRejectModal: false }))}
                            >
                                Cancel
                            </Button>
                        </div>
                    </Modal.Body>
                </Modal>
            </>
        )
    }
}

export default FrontAssignment;